var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useRef, useState } from "react";
import { MeetingDetails } from "./MeetingDetails/MeetingDetails";
import { NewleadPage } from "./Newleadpage";
import { Newproduct } from "./NewProductsblock/Newproduct";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import leadDi from "../../components/Features/LeadDashboard/di/serviceLocator";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SalesToasts from "../../../shared-library/components/Toasts";
import Loader, { LogoLoader } from "../../../shared-library/components/Loader";
import { useSelector } from "react-redux";
import PastIntractionTable from "./LeadPastIntractionTable";
import { config } from "@frameworks/salesjourney/config/domain";
import EdModal from "@frameworks/web/components/generic/edModal";
import SendEmail from "./MeetingDetails/SendEmail";
import LoadingPopup from "../../../shared-library/components/LoadingPopup";
import SuccessPopup from "../../../shared-library/components/SuccessPopup";
import FailurePopup from "../../../shared-library/components/FailurePopup";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import { Accordion, Col, Row } from "react-bootstrap";
import homeDI from "@frameworks/salesjourney/components/Home/di/index";
import GenericToast from "../../../shared-library/components/GenericToast";
import { leadStatusConfig } from "@frameworks/salesjourney/utils/commonLeadStatusConfig";
import GenericTabs from "../../../shared-library/components/GenericTabs";
import loginDI from "@frameworks/salesjourney/components/Login/di/index";
import SubLeadDetails from "./MeetingDetails/SubLeadDetails";
import loaderGIF from "@frameworks/shared-library/assets/images/Reports/loaderGIF.gif";
import di from "../Features/LeadDashboard/di/serviceLocator";
import { IEditLeadAccessPayloadEnum } from "@domains/salesFeatures/Lead/entities/IEditLeadAccess";
import SalesWarningPopup from "../../../shared-library/components/SalesWarningPopup";
import { addEditLeadConstants, initialMeetingObj, productsId, } from "./constant";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
import { alphaNumExp } from "@frameworks/web/utils/regex";
import { getIsAmountValid } from "./constant";
import moment from "moment";
import MinutesOfMeeting from "./MinutesOfMeeting";
import Edelicon from "@frameworks/shared-library/components/Generic/Edelicon";
import GenericTooltip from "@frameworks/shared-library/components/GenericTooltip";
import ToggleSwitch from "@frameworks/web/components/generic/SwitchButton/Switch";
import filterDi from "@frameworks/salesjourney/components/filterDi/serviceLocator";
import EditableMom from "./EditableMom";
import FileAttachPopUp from "./FileAttachPopUp";
export var ELeadTab;
(function (ELeadTab) {
    ELeadTab["NEW_CLIENT"] = "NEW_CLIENT";
    ELeadTab["SELF_LEAD_CREATION"] = "SELF_LEAD_CREATION";
})(ELeadTab || (ELeadTab = {}));
export var initMeetingData = {
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    subSourceId: "",
    assignedTo: "",
    leadSource: "",
    productName: "",
    categoryName: "",
    subCategoryName: "",
    isMobileVerified: false,
    isEmailVerified: false,
    leadType: "",
    acCode: "",
    acName: "",
    bucketId: undefined,
    bucketName: "",
    EntityType: "",
    EntityTypeId: undefined,
    typeOfContact: "",
    didMeetingHappend: false,
    response: "",
    notes: "",
    remarks: "",
    sourceName: "",
    isJointMeeting: false,
    participants: [],
    externalParticipants: [],
    meetingId: "",
    expenses: [],
    primaryOwner: undefined,
    followupMode: "",
    meetingDate: "",
    meetingTime: "",
    subStatus: "",
    amount: "",
    interaction_sub_statusid: undefined,
    interaction_sub_status: "",
    leadId: "",
    meetingFollowUpDate: "",
    meetingFollowUpTime: "",
    productFeedback: "",
    productId: undefined,
    categoryId: undefined,
    subCategoryId: undefined,
    sourceId: undefined,
    responseId: undefined,
    followupModeId: undefined,
    subStatusId: undefined,
    subSourceName: "",
    meetingClosureDate: "",
    displayName: "",
    displayNameId: undefined,
    meetingClosureTime: "",
    feedbacklist: [],
    primaryproductName: "",
    primaryproductid: undefined,
    interaction_priority: "",
    interaction_priority_id: "",
    // priorityId: undefined,
    // priority: "",
    sendMom: false,
    pan: "",
    parentLeadId: "",
    isClient: true,
    isPanVerified: false,
    isParent: false,
    partnerCode: "",
    issuerId: undefined,
    issuerName: "",
    priorityAgeing: undefined,
    priorityFlag: false,
    scheduleDate: "",
    sbCode: undefined,
    sbName: "",
    sbPassout: undefined,
    middleName: "",
    currentFocusedProduct: 0,
    isSentMOM: "No",
    isCheckedForEdit: true,
    isfocus: true,
};
export var Newlead = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var _o = useParams(), leadid = _o.leadid, partnerOrClient = _o.partnerOrClient, isParentOrChild = _o.isParentOrChild, parentLeadId = _o.parentLeadId;
    var _leadAccountRef = useRef();
    leadid = !!leadid
        ? window.atob(leadid) !== "null"
            ? atob(leadid)
            : undefined
        : undefined;
    partnerOrClient = partnerOrClient ? window.atob(partnerOrClient) : undefined;
    isParentOrChild = isParentOrChild ? window.atob(isParentOrChild) : undefined;
    parentLeadId = parentLeadId ? window.atob(parentLeadId) : undefined;
    var pan = /^[A-Z]{3}[ABCFGHLJPTF]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}$/;
    var partnerOrClientValue = !!partnerOrClient && partnerOrClient === "false" ? false : true, isParentOrChildValue = !!isParentOrChild && isParentOrChild === "false" ? false : true;
    // atob(leadid)
    // btoa(leadid)
    // console.log("isParentOrChildValue", isParentOrChildValue);
    var refreshPage = localStorage.getItem(ELocalStorageKeys.RefreshPage);
    var _p = __read(useState([
        initialMeetingObj,
    ]), 2), leadData = _p[0], setLeadData = _p[1];
    var _q = __read(useState(false), 2), subSourceError = _q[0], setSubSourceError = _q[1];
    var _r = __read(React.useState(false), 2), refreshPageValue = _r[0], setRefreshPageValue = _r[1];
    var location = useLocation();
    var searchParams = new URLSearchParams(location.search);
    var uccParams = searchParams.get("ucc");
    var schemeIdParams = searchParams.get("schemeId");
    var bucketIdParams = searchParams.get("bucketId");
    var productIdParams = searchParams.get("productId");
    var categoryIdParams = searchParams.get("categoryId");
    var _s = __read(useState(), 2), parentLeadObj = _s[0], setParentLeadObj = _s[1];
    var meetingRef = useRef(null);
    var pastInteractionRef = useRef(null);
    var _t = __read(React.useState(false), 2), isAddNewLead = _t[0], setIsAddNewLead = _t[1];
    var _u = __read(React.useState([]), 2), panIsMandatory = _u[0], setPanIsMandatory = _u[1];
    var _v = __read(React.useState([]), 2), panError = _v[0], setPanError = _v[1];
    var _w = __read(React.useState(false), 2), isPartnerNewLead = _w[0], setIsPartnerNewLead = _w[1];
    var _x = __read(React.useState(), 2), partnerMainCodeResp = _x[0], setPartnerMainCodeResp = _x[1];
    var _y = __read(useState(true), 2), verifiedPan = _y[0], setVerifiedPan = _y[1];
    var _z = __read(useState({
        searchclient: "",
        sourceName: "",
        subSourceName: "",
        sourceId: 0,
        subSourceId: "",
    }), 2), error = _z[0], setError = _z[1];
    var _0 = __read(useState(false), 2), globleDisable = _0[0], setGlobleDisable = _0[1];
    var _1 = __read(useState(), 2), selectedLead = _1[0], setSelectedLead = _1[1];
    var _2 = __read(useState(false), 2), isVerifiedPanPopUp = _2[0], setIsVerifiedPanPopUp = _2[1];
    var _3 = __read(useState(false), 2), loader = _3[0], setLoader = _3[1];
    var _4 = __read(useState(false), 2), clickToCallLoader = _4[0], setClickToCallLoader = _4[1];
    var _5 = __read(React.useState(false), 2), showSuccess = _5[0], setShowSuccess = _5[1];
    var _6 = __read(React.useState(""), 2), successMsg = _6[0], setSuccessMsg = _6[1];
    var _7 = __read(React.useState(false), 2), isError = _7[0], setIsError = _7[1];
    var _8 = __read(React.useState(false), 2), submitLoader = _8[0], setSubmitLoader = _8[1];
    var _9 = __read(useState(false), 2), emailPopup = _9[0], setEmailPopup = _9[1];
    var _10 = __read(useState(false), 2), emailLoader = _10[0], setEmailLoader = _10[1];
    var _11 = __read(useState(false), 2), emailSuccess = _11[0], setEmailSuccess = _11[1];
    var _12 = __read(useState(false), 2), emailFailure = _12[0], setEmailFailure = _12[1];
    var _13 = __read(React.useState(null), 2), showToast = _13[0], setShowToast = _13[1];
    var _14 = __read(React.useState(false), 2), editAccessToast = _14[0], setEditAccessToast = _14[1];
    var _15 = __read(React.useState({
        isEditAccessErrorState: false,
        isEditAccessLoader: false,
        editAccessMsg: "",
    }), 2), editAccessUiState = _15[0], setEditAccessUiState = _15[1];
    var _16 = __read(React.useState({
        isError: false,
        msg: "",
    }), 2), toadtSuccessMsg = _16[0], setToastSuceessMsg = _16[1];
    var _17 = __read(React.useState(null), 2), toastEmailSuccess = _17[0], setToastEmailSuccess = _17[1];
    var _18 = __read(useState(false), 2), newClient = _18[0], setNewClient = _18[1];
    var _19 = __read(React.useState(false), 2), clearPan = _19[0], setClearPan = _19[1];
    var _20 = __read(React.useState([]), 2), leadIsViewLst = _20[0], setLeadIsViewLst = _20[1];
    var _21 = __read(React.useState(false), 2), newPartner = _21[0], setNewPartner = _21[1];
    var _22 = __read(React.useState(), 2), meetingDetailsFormData = _22[0], setMeetingDetailsFormData = _22[1];
    var _23 = __read(React.useState(false), 2), toastMeetingSelection = _23[0], setToastMeetingSelection = _23[1];
    var navigate = useNavigate();
    var _24 = __read(React.useState(null), 2), leadPitchProducts = _24[0], setLeadPitchProducts = _24[1];
    var _25 = __read(React.useState(ELeadTab.NEW_CLIENT), 2), selectedTab = _25[0], setSelectedTab = _25[1];
    var _26 = __read(useState({}), 2), priorityAgeingData = _26[0], setIPriorityAgeingData = _26[1];
    var _27 = __read(React.useState([]), 2), childLeadData = _27[0], setChildLeadData = _27[1];
    var _28 = __read(useState(false), 2), interestedPrioritywarning = _28[0], setInterestedPrioritywarning = _28[1];
    var _29 = __read(useState([
        {
            data: {
                id: -1,
                isactive: false,
                category_code: -1,
                min_pipeline_val: -1,
                product_code: -1,
            },
            isShowError: false,
            isPipelineAdded: false,
        },
    ]), 2), pipelineValidationData = _29[0], setPipelineValidationData = _29[1];
    var _30 = __read(React.useState(false), 2), isPartnerRegistration = _30[0], setIsPartnerRegistration = _30[1];
    var _31 = __read(useState(false), 2), clientRegister = _31[0], setClientRegister = _31[1];
    var _32 = __read(useState(false), 2), fromInterestedConvPanChange = _32[0], setFromInterestedConvPanChange = _32[1];
    var _33 = __read(useState(), 2), notVerifiedLead = _33[0], setNotVerifiedLead = _33[1];
    var _34 = __read(useState(undefined), 2), meetingDataID = _34[0], setMeetingDataID = _34[1];
    var _35 = __read(useState(false), 2), clearPanForInterestedConverted = _35[0], setClearPanForInterestedConverted = _35[1];
    var _36 = __read(useState(1), 2), priorityDiff = _36[0], setPriorityDiff = _36[1];
    var _37 = __read(useState(undefined), 2), emailTemplateResp = _37[0], setEmailTemplateResp = _37[1];
    var _38 = __read(useState({
        momIsPortfolioSln: "No",
        momIsAOP: "No",
        momIsExpert: "No",
        momParticipants: [],
    }), 2), momFormData = _38[0], setMomFormData = _38[1];
    var _39 = __read(useState(false), 2), momView = _39[0], setMomView = _39[1];
    var _40 = __read(useState(), 2), multipleSelectedLead = _40[0], setMultipleSelectedLead = _40[1];
    var _41 = __read(React.useState(false), 2), multipleLeadsLoader = _41[0], setMultipleLeadsLoader = _41[1];
    var _42 = __read(React.useState(false), 2), momParticipantsError = _42[0], setMomParticipantsError = _42[1];
    var _43 = __read(useState(false), 2), momTemplateloader = _43[0], setMomTemplateloader = _43[1];
    var _44 = __read(useState(false), 2), doneDateConfirmationPopUp = _44[0], setDoneDateConfirmationPopUp = _44[1];
    var _45 = __read(React.useState(false), 2), disableForFocusProduct = _45[0], setDisableForFocusProduct = _45[1];
    var _46 = __read(React.useState(false), 2), showEditableMom = _46[0], setShowEditableMom = _46[1];
    var _47 = __read(React.useState(""), 2), editableMomText = _47[0], setEditableMomText = _47[1];
    var _48 = __read(React.useState(false), 2), isMoMEdited = _48[0], setIsMoMEdited = _48[1];
    var _49 = __read(React.useState(false), 2), attachFilePopUp = _49[0], setAttachFilePopUp = _49[1];
    var _50 = __read(React.useState([]), 2), selectedAttachfile = _50[0], setSelectedAttachfile = _50[1];
    var getParentLeadIdDetails = function (leadId, editChildLead) {
        var leadObj = JSON.parse(JSON.stringify(initMeetingData));
        if (!editChildLead)
            setLoader(true);
        var req = {
            LeadId: leadId,
        };
        leadDi.leads.getViewEditLeadData(req).then(function (resp) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
            if ((((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.isfocus) == true || ((_b = resp === null || resp === void 0 ? void 0 : resp.data) === null || _b === void 0 ? void 0 : _b.isfocus) == false) &&
                ((_c = resp === null || resp === void 0 ? void 0 : resp.data) === null || _c === void 0 ? void 0 : _c.displayNameId) > 0) {
                setDisableForFocusProduct(true);
            }
            if (resp !== null && resp !== undefined) {
                setParentLeadObj(resp);
                leadObj.bucketId = (_d = resp === null || resp === void 0 ? void 0 : resp.data) === null || _d === void 0 ? void 0 : _d.bucketId;
                leadObj.bucketName = (_e = resp === null || resp === void 0 ? void 0 : resp.data) === null || _e === void 0 ? void 0 : _e.bucketName;
                leadObj.productId = (_f = resp === null || resp === void 0 ? void 0 : resp.data) === null || _f === void 0 ? void 0 : _f.productId;
                leadObj.productName = (_g = resp === null || resp === void 0 ? void 0 : resp.data) === null || _g === void 0 ? void 0 : _g.productName;
                leadObj.categoryId = (_h = resp === null || resp === void 0 ? void 0 : resp.data) === null || _h === void 0 ? void 0 : _h.categoryId;
                leadObj.categoryName = (_j = resp === null || resp === void 0 ? void 0 : resp.data) === null || _j === void 0 ? void 0 : _j.categoryName;
                leadObj.displayName = (_k = resp === null || resp === void 0 ? void 0 : resp.data) === null || _k === void 0 ? void 0 : _k.displayName;
                leadObj.displayNameId = (_l = resp === null || resp === void 0 ? void 0 : resp.data) === null || _l === void 0 ? void 0 : _l.displayNameId;
                leadObj.subCategoryId = (_m = resp === null || resp === void 0 ? void 0 : resp.data) === null || _m === void 0 ? void 0 : _m.subCategoryId;
                leadObj.subCategoryName = (_o = resp === null || resp === void 0 ? void 0 : resp.data) === null || _o === void 0 ? void 0 : _o.subCategoryName;
                leadObj.parentLeadId = leadId;
                leadObj.isPanVerified = false;
                leadObj.pan = "";
                leadObj.isClient = true;
                leadObj.isParent = false;
                leadObj.partnerCode = (_p = resp === null || resp === void 0 ? void 0 : resp.data) === null || _p === void 0 ? void 0 : _p.partnerCode;
                leadObj.issuerName = (_q = resp === null || resp === void 0 ? void 0 : resp.data) === null || _q === void 0 ? void 0 : _q.issuerName;
                leadObj.issuerId = (_r = resp === null || resp === void 0 ? void 0 : resp.data) === null || _r === void 0 ? void 0 : _r.issuerId;
                leadObj.isfocus = (_s = resp === null || resp === void 0 ? void 0 : resp.data) === null || _s === void 0 ? void 0 : _s.isfocus;
                if (!editChildLead)
                    setLeadData(JSON.parse(JSON.stringify([leadObj])));
            }
            if (!editChildLead)
                setLoader(false);
        });
    };
    var scrollToPastInteractionRef = function () {
        if (pastInteractionRef)
            pastInteractionRef.current.scrollIntoView({
                block: "start",
                behavior: "smooth",
                inline: "start",
            });
        // setTimeout(() => {
        // }, 800);
    };
    var getLeadPriority = function () { return __awaiter(void 0, void 0, void 0, function () {
        var req;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req = {
                        page: "1",
                        pageSize: "1000",
                    };
                    return [4 /*yield*/, leadDi.leads.getLeadPriority(req).then(function (resp) {
                            var _a;
                            if (resp && ((_a = resp.leadPriority) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                                resp.leadPriority.map(function (leadPriority) {
                                    if ((leadPriority === null || leadPriority === void 0 ? void 0 : leadPriority.name) === "HOT") {
                                        setIPriorityAgeingData(function (prev) { return (__assign(__assign({}, prev), { HOT: {
                                                id: leadPriority.id,
                                                name: leadPriority === null || leadPriority === void 0 ? void 0 : leadPriority.name,
                                                days: (leadPriority === null || leadPriority === void 0 ? void 0 : leadPriority.day)
                                                    ? leadPriority === null || leadPriority === void 0 ? void 0 : leadPriority.day
                                                    : leadStatusConfig.hotDays,
                                            } })); });
                                    }
                                    else if ((leadPriority === null || leadPriority === void 0 ? void 0 : leadPriority.name) === "COLD") {
                                        setIPriorityAgeingData(function (prev) { return (__assign(__assign({}, prev), { COLD: {
                                                id: leadPriority.id,
                                                name: leadPriority === null || leadPriority === void 0 ? void 0 : leadPriority.name,
                                                days: leadPriority === null || leadPriority === void 0 ? void 0 : leadPriority.day,
                                            } })); });
                                    }
                                    else {
                                        setIPriorityAgeingData(function (prev) { return (__assign(__assign({}, prev), { WARM: {
                                                id: leadPriority.id,
                                                name: leadPriority === null || leadPriority === void 0 ? void 0 : leadPriority.name,
                                                days: (leadPriority === null || leadPriority === void 0 ? void 0 : leadPriority.day)
                                                    ? leadPriority === null || leadPriority === void 0 ? void 0 : leadPriority.day
                                                    : leadStatusConfig.warmDays,
                                            } })); });
                                    }
                                });
                            }
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var addNewProduct = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
        var initialRequestPayload = JSON.parse(JSON.stringify(initialMeetingObj));
        var newLead = __assign(__assign({}, initialRequestPayload), { 
            // leadId: selectedLead.data.leadId,
            firstName: (_a = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _a === void 0 ? void 0 : _a.firstName, lastName: (_b = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _b === void 0 ? void 0 : _b.lastName, email: (_c = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _c === void 0 ? void 0 : _c.email, phone: (_d = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _d === void 0 ? void 0 : _d.mobile, acCode: (_e = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _e === void 0 ? void 0 : _e.acCode, sourceId: (_f = leadData[0]) === null || _f === void 0 ? void 0 : _f.sourceId, sourceName: (_g = leadData[0]) === null || _g === void 0 ? void 0 : _g.sourceName, subSourceId: (_h = leadData[0]) === null || _h === void 0 ? void 0 : _h.subSourceId, subSourceName: (_j = leadData[0]) === null || _j === void 0 ? void 0 : _j.subSourceName, isEmailVerified: selectedLead.data.isEmailVerified, isMobileVerified: selectedLead.data.isMobileVerified, typeOfContact: (_k = leadData[0]) === null || _k === void 0 ? void 0 : _k.typeOfContact, meetingDate: (_l = leadData[0]) === null || _l === void 0 ? void 0 : _l.meetingDate, meetingTime: (_m = leadData[0]) === null || _m === void 0 ? void 0 : _m.meetingTime, primaryproductid: (_o = leadData[0]) === null || _o === void 0 ? void 0 : _o.productId, primaryproductName: (_p = leadData[0]) === null || _p === void 0 ? void 0 : _p.productName, isClient: (_q = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _q === void 0 ? void 0 : _q.isClient, isPanVerified: (_r = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _r === void 0 ? void 0 : _r.isPanVerified, isParent: (_s = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _s === void 0 ? void 0 : _s.isParent, pan: (_t = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _t === void 0 ? void 0 : _t.pan, partnerCode: (_u = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _u === void 0 ? void 0 : _u.partnerCode, parentLeadId: (_v = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _v === void 0 ? void 0 : _v.parentLeadId, priorityAgeing: (_w = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _w === void 0 ? void 0 : _w.priorityAgeing, priorityFlag: (_x = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _x === void 0 ? void 0 : _x.priorityFlag, sbCode: undefined, sbName: "", sbPassout: undefined, middleName: (_y = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _y === void 0 ? void 0 : _y.middleName, dob: (_z = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _z === void 0 ? void 0 : _z.dob, UCCCode: (_0 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _0 === void 0 ? void 0 : _0.uccCode, isCheckedForEdit: true, country: (_1 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _1 === void 0 ? void 0 : _1.country, countryprefix: (_2 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _2 === void 0 ? void 0 : _2.countryprefix, countryshortcode: (_3 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _3 === void 0 ? void 0 : _3.countryshortcode, nrinonnri: (_4 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _4 === void 0 ? void 0 : _4.nrinonnri, nrinonnriid: (_5 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _5 === void 0 ? void 0 : _5.nrinonnriid });
        setLeadData(function (ld) { return __spreadArray(__spreadArray([], __read(ld), false), [newLead], false); });
        setPipelineValidationData(function (prevState) {
            var updatedState = (prevState === null || prevState === void 0 ? void 0 : prevState.length) ? __spreadArray([], __read(prevState), false) : [];
            var newObj = {
                data: {
                    id: -1,
                    isactive: false,
                    category_code: -1,
                    min_pipeline_val: -1,
                    product_code: -1,
                },
                isShowError: false,
                isPipelineAdded: false,
            };
            updatedState.push(newObj);
            return updatedState;
        });
    };
    var generateErrorMsg = function () {
        var errorMsg = "";
        var processLeadData = function (dataObj, idx) {
            var _a, _b;
            var hotLead = (dataObj === null || dataObj === void 0 ? void 0 : dataObj.priorityAgeing) > ((_a = priorityAgeingData === null || priorityAgeingData === void 0 ? void 0 : priorityAgeingData.HOT) === null || _a === void 0 ? void 0 : _a.days) &&
                (dataObj === null || dataObj === void 0 ? void 0 : dataObj.interaction_priority_id) === "2";
            var warmLead = (dataObj === null || dataObj === void 0 ? void 0 : dataObj.priorityAgeing) > ((_b = priorityAgeingData === null || priorityAgeingData === void 0 ? void 0 : priorityAgeingData.WARM) === null || _b === void 0 ? void 0 : _b.days) &&
                (dataObj === null || dataObj === void 0 ? void 0 : dataObj.interaction_priority_id) === "3";
            if (hotLead || warmLead) {
                errorMsg += "".concat(leadData.length === 1
                    ? "This is a ".concat(dataObj === null || dataObj === void 0 ? void 0 : dataObj.interaction_priority, " lead and the overall ageing of lead is crossing ").concat(hotLead ? "30" : "60", " days. ")
                    : "".concat(idx + 1, ". ").concat(dataObj === null || dataObj === void 0 ? void 0 : dataObj.productName, ", ").concat(dataObj === null || dataObj === void 0 ? void 0 : dataObj.categoryName, " is a ").concat(dataObj === null || dataObj === void 0 ? void 0 : dataObj.interaction_priority, " lead and the overall ageing of lead is crossing ").concat(hotLead ? "30" : "60", " days.<br/>"));
            }
        };
        leadData === null || leadData === void 0 ? void 0 : leadData.forEach(processLeadData);
        return errorMsg;
    };
    var setSuccessStageOpen = function (msg, isView, leadSavedObj) {
        var _a;
        setShowSuccess(true);
        if (isView && !!leadSavedObj && ((_a = leadSavedObj === null || leadSavedObj === void 0 ? void 0 : leadSavedObj.leadId) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var leadViewList = [leadSavedObj];
            setSuccessMsg("");
            setLeadIsViewLst(leadViewList);
        }
        else {
            setLeadIsViewLst([]);
            setSuccessMsg(msg);
        }
    };
    var clickToCallApi = function () {
        setClickToCallLoader(true);
        var req = {
            callingSource: "mobile",
            leadid: selectedLead.data.leadId,
            mobile: selectedLead.data.mobile,
            userid: null,
        };
        leadDi.leads
            .clickToCall(req)
            .then(function (response) {
            setShowToast(true);
            setToastSuceessMsg({
                isError: false,
                msg: response,
            });
            setClickToCallLoader(false);
        })
            .catch(function (error) {
            setClickToCallLoader(false);
            setShowToast(true);
            setToastSuceessMsg({
                isError: true,
                msg: error,
            });
        });
    };
    // useEffect(() => {
    //   if (!!leadid) {
    //     getViewLeadId(leadid);
    //     //navigate("/leadpage", { replace: true });
    //   }
    // }, [leadid]);
    var leadPastInteractions = useSelector(function (state) {
        return state.Lead.PastIntraction.reducersData.leadPastInteractions;
    });
    var showHideFields = function (leadData) {
        var _a;
        var leadConfigObject = {
            hideSchemeData: false,
        };
        if (!!leadData &&
            !!(leadData === null || leadData === void 0 ? void 0 : leadData.bucketId) &&
            ((_a = leadData === null || leadData === void 0 ? void 0 : leadData.bucketId) === null || _a === void 0 ? void 0 : _a.toString()) === leadStatusConfig.acquisitionBucketId) {
            leadConfigObject.hideSchemeData = true;
        }
        return leadConfigObject;
    };
    var showHideForLoginType = function () {
        var _a, _b, _c, _d, _e, _f;
        var leadConfigObject = {
            leadSelfCreation: false,
            allowToSeePartnerRegistration: false,
            toShowOnlyClientTab: false,
            labelText: "Search Client",
            searchPlaceHolder: "Search with Mobile No. / Email / Name/ Account Code / PAN",
            addParentLeadId: false,
            requestPayloadIsParentFlag: false,
            selectSearchFor: "Client",
            showSubChildSection: false,
            showSubParentSection: false,
            filterStatusList: false,
            isClientTab: false,
            isPartnerTab: false,
            skipPartnerFromProductApi: false,
            selectedTab: "",
        };
        var loginType = loginDI.login.getIsRMPartnerFRM();
        if ((loginType.isFRM || loginType.isPartner || loginType.isRM) &&
            selectedTab === ELeadTab.NEW_CLIENT) {
            leadConfigObject.isClientTab = true;
        }
        if (loginType.isFRM && selectedTab === ELeadTab.NEW_CLIENT) {
            if (!leadid) {
                leadConfigObject.skipPartnerFromProductApi = true;
            }
        }
        if (loginType.isPartner && selectedTab === ELeadTab.NEW_CLIENT) {
            if (!leadid) {
                leadConfigObject.skipPartnerFromProductApi = true;
            }
        }
        if ((loginType.isFRM || loginType.isPartner) &&
            (selectedTab === ELeadTab.SELF_LEAD_CREATION || leadid)) {
            if (loginType.isPartner && selectedTab === ELeadTab.SELF_LEAD_CREATION) {
                leadConfigObject.skipPartnerFromProductApi = true;
            }
            leadConfigObject.isPartnerTab = true;
        }
        if (loginType.isPartner &&
            (selectedTab === ELeadTab.SELF_LEAD_CREATION || leadid)) {
            leadConfigObject.leadSelfCreation = true;
            leadConfigObject.labelText = "Search Partner";
            leadConfigObject.searchPlaceHolder =
                "Search with Partner Name, Partner Code, PAN, UPC.";
            if ((loginType.isFRM || loginType.isPartner) &&
                leadid &&
                isParentOrChildValue) {
                leadConfigObject.showSubChildSection = true;
            }
            if (leadid && partnerOrClientValue) {
                leadConfigObject.leadSelfCreation = false;
                leadConfigObject.labelText = "Search Client";
                leadConfigObject.searchPlaceHolder =
                    "Search with Mobile No. / Email / Name/ Account Code / PAN";
            }
            if (parentLeadId && partnerOrClientValue && isParentOrChildValue) {
                leadConfigObject.leadSelfCreation = false;
                leadConfigObject.addParentLeadId = true;
                leadConfigObject.labelText = "Search Client";
                leadConfigObject.searchPlaceHolder =
                    "Search with Mobile No. / Email / Name/ Account Code / PAN";
            }
        }
        else {
            if ((loginType.isPartner || loginType.isFRM) &&
                parentLeadId &&
                partnerOrClientValue &&
                isParentOrChildValue) {
                leadConfigObject.leadSelfCreation = false;
                leadConfigObject.addParentLeadId = true;
                leadConfigObject.labelText = "Search Client";
                leadConfigObject.searchPlaceHolder =
                    "Search with Mobile No. / Email / Name/ Account Code / PAN";
            }
            if ((loginType.isFRM || loginType.isPartner) &&
                leadid &&
                isParentOrChildValue) {
                leadConfigObject.showSubChildSection = true;
            }
            if (loginType.isFRM &&
                (selectedTab === ELeadTab.SELF_LEAD_CREATION || leadid)) {
                leadConfigObject.allowToSeePartnerRegistration = true;
                leadConfigObject.labelText = "Search Partner";
                leadConfigObject.searchPlaceHolder =
                    "Search with Partner Name, Partner Code, PAN, UPC.";
                if ((leadid || ((_a = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _a === void 0 ? void 0 : _a.leadId)) && !isParentOrChildValue) {
                    leadConfigObject.filterStatusList = false;
                }
                else
                    leadConfigObject.filterStatusList = true;
                if (leadid && partnerOrClientValue) {
                    leadConfigObject.filterStatusList = false;
                    leadConfigObject.allowToSeePartnerRegistration = false;
                    leadConfigObject.labelText = "Search Client";
                    leadConfigObject.searchPlaceHolder =
                        "Search with Mobile No. / Email / Name/ Account Code / PAN";
                }
                if (parentLeadId && partnerOrClientValue && isParentOrChildValue) {
                    leadConfigObject.filterStatusList = false;
                    leadConfigObject.addParentLeadId = true;
                    leadConfigObject.labelText = "Search Client";
                    leadConfigObject.searchPlaceHolder =
                        "Search with Mobile No. / Email / Name/ Account Code / PAN";
                }
            }
            // if (loginType.isRM || loginType.isFRM) {
            //   leadConfigObject.toShowOnlyClientTab = true;
            //   leadConfigObject.labelText = "Search Client";
            // }
            leadConfigObject.leadSelfCreation = false;
        }
        if ((loginType.isFRM || loginType.isPartner) &&
            selectedTab === ELeadTab.SELF_LEAD_CREATION) {
            leadConfigObject.requestPayloadIsParentFlag = true;
            if ((_b = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _b === void 0 ? void 0 : _b.leadId) {
                leadConfigObject.filterStatusList = false;
            }
        }
        if ((loginType.isFRM || loginType.isPartner) &&
            leadid &&
            !!((_c = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _c === void 0 ? void 0 : _c.parentLeadId) &&
            ((_d = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _d === void 0 ? void 0 : _d.parentLeadId) &&
            ((_f = (_e = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _e === void 0 ? void 0 : _e.parentLeadId) === null || _f === void 0 ? void 0 : _f.length) > 0 &&
            !isParentOrChildValue) {
            leadConfigObject.showSubParentSection = true;
        }
        if (selectedTab && selectedTab === ELeadTab.SELF_LEAD_CREATION) {
            leadConfigObject.selectSearchFor = "Partner";
        }
        leadConfigObject.selectedTab = selectedTab;
        return leadConfigObject;
    };
    var getTabsList = function () {
        var _a;
        var tabList = [
            {
                title: "Client",
                eventKey: ELeadTab.NEW_CLIENT,
                tabContent: generateMainComp(),
            },
            {
                title: "Partner",
                eventKey: ELeadTab.SELF_LEAD_CREATION,
                tabContent: generateMainComp(),
            },
        ];
        if (loginDI.login.getIsRMPartnerFRM().isPartner) {
            tabList = [
                {
                    title: "Client",
                    eventKey: ELeadTab.NEW_CLIENT,
                    tabContent: generateMainComp(),
                },
                {
                    title: "Self Lead Creation",
                    eventKey: ELeadTab.SELF_LEAD_CREATION,
                    tabContent: generateMainComp(),
                },
            ];
        }
        if ((_a = showHideForLoginType()) === null || _a === void 0 ? void 0 : _a.toShowOnlyClientTab) {
            tabList.splice(1, 1);
        }
        return tabList;
    };
    var getValidationPipelineAmt = function (productId, assetId, currentProductIndex) {
        return new Promise(function (resolve, reject) {
            di.leads
                .getValidationPipelineAmount({ productId: productId, assetId: assetId })
                .then(function (data) {
                var _a;
                var index = data.data.findIndex(function (item) { return item.product_code === productId; });
                var localPipelineValidationData = __spreadArray([], __read(pipelineValidationData), false);
                localPipelineValidationData[currentProductIndex] = {
                    data: data.data[index],
                    isShowError: false,
                    isPipelineAdded: false,
                    categoryName: (_a = meetingDetailsFormData.categoryName) !== null && _a !== void 0 ? _a : "",
                };
                if (!!meetingDetailsFormData.amount) {
                    localPipelineValidationData[currentProductIndex].isPipelineAdded =
                        true;
                    localPipelineValidationData[currentProductIndex].isShowError =
                        getIsAmountValid(meetingDetailsFormData.amount, localPipelineValidationData[currentProductIndex].data
                            .min_pipeline_val);
                }
                // meetingRef?.current.validatePipeline(localPipelineValidationData);
                setPipelineValidationData(localPipelineValidationData);
                resolve(localPipelineValidationData);
            })
                .catch(function (error) {
                console.log(error);
                reject(error);
            });
        });
    };
    var panFromInterestedConverted = function () {
        var _a;
        var pan = "";
        if ((leadData === null || leadData === void 0 ? void 0 : leadData.length) > 0) {
            pan = (_a = leadData[meetingDataID]) === null || _a === void 0 ? void 0 : _a.pan;
        }
        return pan;
    };
    useEffect(function () {
        if (parentLeadId !== null &&
            parentLeadId !== undefined &&
            parentLeadId !== "") {
            getParentLeadIdDetails(parentLeadId, false);
        }
    }, [parentLeadId]);
    var updateSubSourceIdForLeadData = function (sourceId) {
        if (leadData && (leadData === null || leadData === void 0 ? void 0 : leadData.length) > 0) {
            setLeadData(function (leadData) {
                leadData = leadData.map(function (record) {
                    var _a, _b, _c;
                    record.subSourceId = (_a = sourceId === null || sourceId === void 0 ? void 0 : sourceId.value) === null || _a === void 0 ? void 0 : _a.toString();
                    record.subSourceName = sourceId === null || sourceId === void 0 ? void 0 : sourceId.label;
                    if ((_b = loginDI.login.getIsRMPartnerFRM()) === null || _b === void 0 ? void 0 : _b.isPartner)
                        record.partnerCode = (_c = sourceId === null || sourceId === void 0 ? void 0 : sourceId.value) === null || _c === void 0 ? void 0 : _c.toString();
                    return record;
                });
                return leadData;
            });
        }
    };
    var panClearOnCancel = function () {
        if (leadData && (leadData === null || leadData === void 0 ? void 0 : leadData.length) > 0) {
            setLeadData(function (leadData) {
                leadData = leadData.map(function (record, idx) {
                    record.pan = "";
                    return record;
                });
                return leadData;
            });
        }
    };
    var checkPanDedupe = function (leadData) {
        if (leadData && leadData.length > 0) {
            leadData.map(function (record) {
                if ((record === null || record === void 0 ? void 0 : record.subStatusId) ===
                    Number(leadStatusConfig.interestedInteractionStatusId) &&
                    (record === null || record === void 0 ? void 0 : record.interaction_sub_statusid) ===
                        Number(leadStatusConfig.convertedInteractionSubStatusId)) {
                    var meetingDataObj = record;
                    var initialRequestPayload = initialMeetingObj;
                    initialRequestPayload.phone = meetingDataObj === null || meetingDataObj === void 0 ? void 0 : meetingDataObj.phone;
                    initialRequestPayload.email = meetingDataObj === null || meetingDataObj === void 0 ? void 0 : meetingDataObj.email;
                    initialRequestPayload.leadId = meetingDataObj === null || meetingDataObj === void 0 ? void 0 : meetingDataObj.leadId;
                    initialRequestPayload.subStatusId = meetingDataObj === null || meetingDataObj === void 0 ? void 0 : meetingDataObj.subStatusId;
                    initialRequestPayload.interaction_sub_statusid =
                        meetingDataObj === null || meetingDataObj === void 0 ? void 0 : meetingDataObj.interaction_sub_statusid;
                    initialRequestPayload.subCategoryId = meetingDataObj === null || meetingDataObj === void 0 ? void 0 : meetingDataObj.subCategoryId;
                    initialRequestPayload.displayNameId = meetingDataObj === null || meetingDataObj === void 0 ? void 0 : meetingDataObj.displayNameId;
                    initialRequestPayload.productId = meetingDataObj === null || meetingDataObj === void 0 ? void 0 : meetingDataObj.productId;
                    initialRequestPayload.categoryId = meetingDataObj === null || meetingDataObj === void 0 ? void 0 : meetingDataObj.categoryId;
                    initialRequestPayload.bucketId = meetingDataObj === null || meetingDataObj === void 0 ? void 0 : meetingDataObj.bucketId;
                    initialRequestPayload.acCode = meetingDataObj === null || meetingDataObj === void 0 ? void 0 : meetingDataObj.acCode;
                    initialRequestPayload.isClient = meetingDataObj === null || meetingDataObj === void 0 ? void 0 : meetingDataObj.isClient;
                    initialRequestPayload.partnerCode = meetingDataObj === null || meetingDataObj === void 0 ? void 0 : meetingDataObj.partnerCode;
                    initialRequestPayload.isParent = meetingDataObj === null || meetingDataObj === void 0 ? void 0 : meetingDataObj.isParent;
                    initialRequestPayload.parentLeadId = meetingDataObj === null || meetingDataObj === void 0 ? void 0 : meetingDataObj.parentLeadId;
                    initialRequestPayload.pan = meetingDataObj === null || meetingDataObj === void 0 ? void 0 : meetingDataObj.pan;
                    initialRequestPayload.isPanVerified = meetingDataObj === null || meetingDataObj === void 0 ? void 0 : meetingDataObj.isPanVerified;
                    leadDi.leads
                        .checkPanDedupe(initialRequestPayload)
                        .then(function (resp) {
                        if (resp && (resp === null || resp === void 0 ? void 0 : resp.response) === "Success") {
                            setShowSuccess(false);
                            setSubmitLoader(true);
                            return true;
                        }
                        else {
                            setShowSuccess(true);
                            setSubmitLoader(false);
                            setIsError(true);
                            setSuccessMsg(resp === null || resp === void 0 ? void 0 : resp.responseDescription);
                            return false;
                        }
                    })
                        .catch(function (Resp) {
                        setShowSuccess(true);
                        setSubmitLoader(false);
                        setIsError(true);
                        setSuccessMsg("Something went wrong. please try again after sometime.");
                        return false;
                    });
                }
                else {
                    return true;
                }
            });
        }
        else {
            return true;
        }
    };
    useEffect(function () {
        if (((clientRegister || isPartnerRegistration) &&
            fromInterestedConvPanChange) ||
            isVerifiedPanPopUp) {
            localStorage.setItem("leadData", JSON.stringify(leadData));
        }
    }, [clientRegister, isVerifiedPanPopUp]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41, _42, _43, _44, _45, _46, _47, _48, _49, _50, _51, _52, _53, _54, _55, _56, _57, _58, _59, _60, _61, _62, _63, _64, _65, _66, _67, _68, _69, _70, _71, _72, _73, _74, _75, _76, _77, _78, _79, _80, _81, _82, _83, _84;
        if (selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) {
            setLoader(true);
            if (((_a = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _a === void 0 ? void 0 : _a.leadId) || leadid || newClient) {
                var lead = {
                    productId: selectedLead.data.productId,
                    categoryId: selectedLead.data.categoryId,
                    bucketId: selectedLead.data.bucketId,
                    currentFocusedProduct: 0,
                    responseId: undefined,
                    email: selectedLead.data.email,
                    phone: selectedLead.data.mobile,
                    subCategoryId: selectedLead.data.subCategoryId,
                    displayName: selectedLead.data.displayName,
                    displayNameId: selectedLead.data.displayNameId,
                    assignedTo: selectedLead.data.assignTo,
                    leadSource: selectedLead.data.leadSource,
                    isMobileVerified: selectedLead.data.isMobileVerified,
                    isEmailVerified: selectedLead.data.isEmailVerified,
                    leadType: selectedLead.data.leadType,
                    participants: selectedLead.data.didMeetingHappend &&
                        selectedLead.data.isJointMeeting
                        ? selectedLead.data.participants
                        : null,
                    externalParticipants: selectedLead.data.didMeetingHappend &&
                        selectedLead.data.isJointMeeting
                        ? selectedLead.data.externalParticipants
                        : null,
                    primaryOwner: selectedLead.data.primaryOwner,
                    meetingId: selectedLead.data.meetingId,
                    expenses: selectedLead.data.expenses,
                    followupModeId: undefined,
                    followupMode: "",
                    subStatusId: selectedLead.data.subStatusId,
                    interaction_sub_statusid: selectedLead.data.interaction_sub_statusid,
                    interaction_sub_status: selectedLead.data.interaction_sub_status,
                    meetingFollowUpDate: "",
                    meetingFollowUpTime: "",
                    productFeedback: selectedLead.data.productFeedback,
                    firstName: selectedLead.data.firstName,
                    lastName: selectedLead.data.lastName,
                    sourceId: selectedLead.data.sourceId,
                    subSourceId: selectedLead.data.subSourceId,
                    productName: selectedLead.data.productName,
                    categoryName: selectedLead.data.categoryName,
                    subCategoryName: selectedLead.data.subCategoryName,
                    acCode: selectedLead.data.acCode,
                    acName: selectedLead.data.acName,
                    bucketName: selectedLead.data.bucketName,
                    typeOfContact: (_b = selectedLead.data) === null || _b === void 0 ? void 0 : _b.typeOfContact,
                    didMeetingHappend: selectedLead.data.didMeetingHappend,
                    response: "",
                    notes: selectedLead.data.notes,
                    remarks: selectedLead.data.remarks,
                    sourceName: selectedLead.data.sourceName,
                    isJointMeeting: selectedLead.data.isJointMeeting,
                    meetingDate: selectedLead.data.meetingDate,
                    meetingTime: selectedLead.data.meetingTime,
                    subStatus: selectedLead.data.subStatus,
                    amount: selectedLead.data.amount === "0" &&
                        !(Number(selectedLead.data.amount) > 0)
                        ? ""
                        : selectedLead.data.amount,
                    leadId: selectedLead.data.leadId,
                    subSourceName: selectedLead.data.subSourceName,
                    meetingClosureDate: selectedLead.data.meetingClosureDate,
                    meetingClosureTime: selectedLead.data.meetingClosureTime,
                    feedbacklist: selectedLead.data.feedbacklist,
                    primaryproductName: selectedLead.data.productName,
                    primaryproductid: selectedLead.data.productId,
                    interaction_priority: (_c = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _c === void 0 ? void 0 : _c.interaction_priority,
                    interaction_priority_id: (_d = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _d === void 0 ? void 0 : _d.interaction_priority_id,
                    isClient: (_e = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _e === void 0 ? void 0 : _e.isClient,
                    isPanVerified: (_f = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _f === void 0 ? void 0 : _f.isPanVerified,
                    isParent: (_g = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _g === void 0 ? void 0 : _g.isParent,
                    pan: (_h = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _h === void 0 ? void 0 : _h.pan,
                    parentLeadId: (_j = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _j === void 0 ? void 0 : _j.parentLeadId,
                    issuerId: (_k = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _k === void 0 ? void 0 : _k.issuerId,
                    issuerName: (_l = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _l === void 0 ? void 0 : _l.issuerName,
                    priorityAgeing: (_m = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _m === void 0 ? void 0 : _m.priorityAgeing,
                    priorityFlag: (_o = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _o === void 0 ? void 0 : _o.priorityFlag,
                    sbCode: (_p = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _p === void 0 ? void 0 : _p.sbCode,
                    sbName: (_q = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _q === void 0 ? void 0 : _q.sbName,
                    sbPassout: (_r = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _r === void 0 ? void 0 : _r.sbPassout,
                    middleName: (_t = (_s = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _s === void 0 ? void 0 : _s.middleName) !== null && _t !== void 0 ? _t : "",
                    dob: (_u = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _u === void 0 ? void 0 : _u.dob,
                    EntityType: (_v = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _v === void 0 ? void 0 : _v.entityType,
                    EntityTypeId: (_w = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _w === void 0 ? void 0 : _w.entityTypeId,
                    UCCCode: (_x = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _x === void 0 ? void 0 : _x.uccCode,
                    isCheckedForEdit: true,
                    country: (_y = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _y === void 0 ? void 0 : _y.country,
                    countryprefix: (_z = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _z === void 0 ? void 0 : _z.countryprefix,
                    countryshortcode: (_0 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _0 === void 0 ? void 0 : _0.countryshortcode,
                    nrinonnri: (_1 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _1 === void 0 ? void 0 : _1.nrinonnri,
                    nrinonnriid: (_2 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _2 === void 0 ? void 0 : _2.nrinonnriid,
                    isfocus: !!((_3 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _3 === void 0 ? void 0 : _3.isfocus),
                    closuremonth: (_4 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _4 === void 0 ? void 0 : _4.closuremonth,
                    // priorityId: selectedLead?.data?.priorityId,
                    // priority: selectedLead?.data?.priority,
                };
                var localData = JSON.parse(localStorage.getItem("leadData"));
                if (refreshPageValue) {
                    var newLeadInitialSearch = __assign(__assign({}, initialMeetingObj), { firstName: (_5 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _5 === void 0 ? void 0 : _5.firstName, lastName: (_6 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _6 === void 0 ? void 0 : _6.lastName, email: (_7 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _7 === void 0 ? void 0 : _7.email, phone: (_8 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _8 === void 0 ? void 0 : _8.mobile, acCode: (_9 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _9 === void 0 ? void 0 : _9.acCode, sourceId: (_10 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _10 === void 0 ? void 0 : _10.sourceId, sourceName: (_11 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _11 === void 0 ? void 0 : _11.sourceName, subSourceId: (_12 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _12 === void 0 ? void 0 : _12.subSourceId, subSourceName: (_13 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _13 === void 0 ? void 0 : _13.subSourceName, isEmailVerified: (_14 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _14 === void 0 ? void 0 : _14.isEmailVerified, isMobileVerified: (_15 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _15 === void 0 ? void 0 : _15.isMobileVerified, isClient: (_16 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _16 === void 0 ? void 0 : _16.isClient, isPanVerified: (_17 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _17 === void 0 ? void 0 : _17.isPanVerified, isParent: (_18 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _18 === void 0 ? void 0 : _18.isParent, pan: (_19 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _19 === void 0 ? void 0 : _19.pan, parentLeadId: undefined, sbCode: undefined, sbName: "", sbPassout: undefined, middleName: (_20 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _20 === void 0 ? void 0 : _20.middleName, dob: (_21 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _21 === void 0 ? void 0 : _21.dob, fullName: (_22 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _22 === void 0 ? void 0 : _22.fullName, isCheckedForEdit: true, nrinonnri: (_23 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _23 === void 0 ? void 0 : _23.nrinonnri, nrinonnriid: (_24 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _24 === void 0 ? void 0 : _24.nrinonnriid, country: (_25 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _25 === void 0 ? void 0 : _25.country, countryprefix: (_26 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _26 === void 0 ? void 0 : _26.countryprefix, countryshortcode: (_27 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _27 === void 0 ? void 0 : _27.countryshortcode });
                    setLeadData(JSON.parse(JSON.stringify([newLeadInitialSearch])));
                    setRefreshPageValue(false);
                    if (!!(newLeadInitialSearch === null || newLeadInitialSearch === void 0 ? void 0 : newLeadInitialSearch.acCode) ||
                        !!(newLeadInitialSearch === null || newLeadInitialSearch === void 0 ? void 0 : newLeadInitialSearch.leadId)) {
                        getMultipleLeads(newLeadInitialSearch === null || newLeadInitialSearch === void 0 ? void 0 : newLeadInitialSearch.leadId, newLeadInitialSearch.acCode);
                    }
                }
                else {
                    if ((localData === null || localData === void 0 ? void 0 : localData.length) > 0) {
                        var updatedData = localData === null || localData === void 0 ? void 0 : localData.map(function (meetingData, idx) {
                            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                            return (__assign(__assign({}, meetingData), { isPanVerified: selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data.isPanVerified, isEmailVerified: selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data.isEmailVerified, isMobileVerified: selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data.isMobileVerified, pan: selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data.pan, dob: selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data.dob, isClient: selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data.isClient, phone: (_a = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _a === void 0 ? void 0 : _a.mobile, email: (_b = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _b === void 0 ? void 0 : _b.email, firstName: (_c = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _c === void 0 ? void 0 : _c.firstName, middleName: ((_d = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _d === void 0 ? void 0 : _d.middleName)
                                    ? (_e = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _e === void 0 ? void 0 : _e.middleName
                                    : "", lastName: ((_f = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _f === void 0 ? void 0 : _f.lastName)
                                    ? (_g = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _g === void 0 ? void 0 : _g.lastName
                                    : "", EntityType: (_h = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _h === void 0 ? void 0 : _h.entityType, EntityTypeId: (_j = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _j === void 0 ? void 0 : _j.entityTypeId }));
                        });
                        if (!!parentLeadId &&
                            (parentLeadId === null || parentLeadId === void 0 ? void 0 : parentLeadId.length) > 0 &&
                            !!parentLeadObj &&
                            (parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data)) {
                            var issuerId = 0, isssuerName = undefined;
                            if (leadData && (leadData === null || leadData === void 0 ? void 0 : leadData.length) > 0) {
                                issuerId = (_28 = leadData[0]) === null || _28 === void 0 ? void 0 : _28.issuerId;
                                isssuerName = (_29 = leadData[0]) === null || _29 === void 0 ? void 0 : _29.issuerName;
                            }
                            updatedData[0].bucketId = (_30 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _30 === void 0 ? void 0 : _30.bucketId;
                            updatedData[0].bucketName = (_31 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _31 === void 0 ? void 0 : _31.bucketName;
                            updatedData[0].productId = (_32 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _32 === void 0 ? void 0 : _32.productId;
                            updatedData[0].productName = (_33 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _33 === void 0 ? void 0 : _33.productName;
                            updatedData[0].categoryId = (_34 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _34 === void 0 ? void 0 : _34.categoryId;
                            updatedData[0].categoryName = (_35 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _35 === void 0 ? void 0 : _35.categoryName;
                            updatedData[0].displayName = (_36 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _36 === void 0 ? void 0 : _36.displayName;
                            updatedData[0].displayNameId = (_37 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _37 === void 0 ? void 0 : _37.displayNameId;
                            updatedData[0].subCategoryId = (_38 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _38 === void 0 ? void 0 : _38.subCategoryId;
                            updatedData[0].primaryproductName =
                                (_39 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _39 === void 0 ? void 0 : _39.productName;
                            updatedData[0].primaryproductid = (_40 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _40 === void 0 ? void 0 : _40.productId;
                            updatedData[0].subCategoryName =
                                (_41 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _41 === void 0 ? void 0 : _41.subCategoryName;
                            updatedData[0].parentLeadId = parentLeadId;
                            updatedData[0].isClient = true;
                            updatedData[0].isParent = false;
                            updatedData[0].partnerCode = (_42 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _42 === void 0 ? void 0 : _42.partnerCode;
                            updatedData[0].leadId = "";
                            updatedData[0].issuerId = ((_43 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _43 === void 0 ? void 0 : _43.issuerId)
                                ? (_44 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _44 === void 0 ? void 0 : _44.issuerId
                                : issuerId;
                            updatedData[0].issuerName = ((_45 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _45 === void 0 ? void 0 : _45.issuerName)
                                ? (_46 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _46 === void 0 ? void 0 : _46.issuerName
                                : isssuerName;
                        }
                        setLeadData(JSON.parse(JSON.stringify(updatedData)));
                        setIsVerifiedPanPopUp(false);
                    }
                    else {
                        if (!!parentLeadId &&
                            (parentLeadId === null || parentLeadId === void 0 ? void 0 : parentLeadId.length) > 0 &&
                            !!parentLeadObj &&
                            (parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data)) {
                            var issuerId = 0, isssuerName = undefined;
                            if (leadData && (leadData === null || leadData === void 0 ? void 0 : leadData.length) > 0) {
                                issuerId = (_47 = leadData[0]) === null || _47 === void 0 ? void 0 : _47.issuerId;
                                isssuerName = (_48 = leadData[0]) === null || _48 === void 0 ? void 0 : _48.issuerName;
                            }
                            lead.bucketId = (_49 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _49 === void 0 ? void 0 : _49.bucketId;
                            lead.bucketName = (_50 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _50 === void 0 ? void 0 : _50.bucketName;
                            lead.productId = (_51 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _51 === void 0 ? void 0 : _51.productId;
                            lead.productName = (_52 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _52 === void 0 ? void 0 : _52.productName;
                            lead.categoryId = (_53 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _53 === void 0 ? void 0 : _53.categoryId;
                            lead.categoryName = (_54 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _54 === void 0 ? void 0 : _54.categoryName;
                            lead.displayName = (_55 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _55 === void 0 ? void 0 : _55.displayName;
                            lead.displayNameId = (_56 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _56 === void 0 ? void 0 : _56.displayNameId;
                            lead.subCategoryId = (_57 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _57 === void 0 ? void 0 : _57.subCategoryId;
                            lead.subCategoryName = (_58 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _58 === void 0 ? void 0 : _58.subCategoryName;
                            lead.primaryproductName = (_59 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _59 === void 0 ? void 0 : _59.productName;
                            lead.primaryproductid = (_60 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _60 === void 0 ? void 0 : _60.productId;
                            lead.parentLeadId = parentLeadId;
                            lead.isPanVerified = false;
                            lead.pan = "";
                            lead.isClient = true;
                            lead.isParent = false;
                            lead.partnerCode = (_61 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _61 === void 0 ? void 0 : _61.partnerCode;
                            lead.leadId = "";
                            lead.issuerId = ((_62 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _62 === void 0 ? void 0 : _62.issuerId)
                                ? (_63 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _63 === void 0 ? void 0 : _63.issuerId
                                : issuerId;
                            lead.issuerName = ((_64 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _64 === void 0 ? void 0 : _64.issuerName)
                                ? (_65 = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _65 === void 0 ? void 0 : _65.issuerName
                                : isssuerName;
                        }
                        if (newClient && ((_66 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _66 === void 0 ? void 0 : _66.leadId)) {
                            lead.leadId = (_67 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _67 === void 0 ? void 0 : _67.leadId;
                        }
                        setLeadData(JSON.parse(JSON.stringify([lead])));
                        if (!!(lead === null || lead === void 0 ? void 0 : lead.acCode) || !!(lead === null || lead === void 0 ? void 0 : lead.leadId)) {
                            getMultipleLeads(lead === null || lead === void 0 ? void 0 : lead.leadId, lead.acCode);
                        }
                    }
                }
                if (newClient) {
                    // new client flow
                    setNewClient(false);
                }
            }
            else {
                if (newPartner) {
                    var lead = initMeetingData;
                    lead.firstName = selectedLead.data.firstName;
                    lead.lastName = selectedLead.data.lastName;
                    lead.email = selectedLead.data.email;
                    lead.phone = selectedLead.data.mobile;
                    lead.acCode = selectedLead.data.acCode;
                    lead.sourceId = selectedLead.data.sourceId;
                    lead.sourceName = selectedLead.data.sourceName;
                    lead.subSourceId = selectedLead.data.subSourceId;
                    lead.subSourceName = selectedLead.data.subSourceName;
                    lead.isEmailVerified = selectedLead.data.isEmailVerified;
                    lead.isMobileVerified = selectedLead.data.isMobileVerified;
                    lead.pan = (_68 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _68 === void 0 ? void 0 : _68.pan;
                    lead.isPanVerified = (_69 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _69 === void 0 ? void 0 : _69.isPanVerified;
                    lead.isParent = (_70 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _70 === void 0 ? void 0 : _70.isParent;
                    lead.isClient = (_71 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _71 === void 0 ? void 0 : _71.isClient;
                    lead.parentLeadId = (_72 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _72 === void 0 ? void 0 : _72.parentLeadId;
                    lead.partnerCode = (_73 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _73 === void 0 ? void 0 : _73.partnerCode;
                    lead.middleName = (_74 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _74 === void 0 ? void 0 : _74.middleName;
                    lead.dob = (_75 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _75 === void 0 ? void 0 : _75.dob;
                    setLeadData(JSON.parse(JSON.stringify([lead])));
                    if (newPartner) {
                        setNewPartner(false);
                    }
                }
                else {
                    setLeadData(function (lead) {
                        return lead === null || lead === void 0 ? void 0 : lead.map(function (l, i) {
                            var _a, _b, _c, _d, _e, _f, _g, _h;
                            return __assign(__assign({}, l), { leadId: leadid && i == 0 ? selectedLead.data.leadId : l === null || l === void 0 ? void 0 : l.leadId, firstName: selectedLead.data.firstName, lastName: selectedLead.data.lastName, email: selectedLead.data.email, phone: selectedLead.data.mobile, acCode: selectedLead.data.acCode, sourceId: selectedLead.data.sourceId, sourceName: selectedLead.data.sourceName, subSourceId: selectedLead.data.subSourceId, subSourceName: selectedLead.data.subSourceName, isEmailVerified: selectedLead.data.isEmailVerified, isMobileVerified: selectedLead.data.isMobileVerified, pan: selectedLead.data.pan, UCCCode: ((_a = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _a === void 0 ? void 0 : _a.isClient) && ((_b = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _b === void 0 ? void 0 : _b.uccCode)
                                    ? (_c = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _c === void 0 ? void 0 : _c.uccCode
                                    : "", nrinonnri: (_d = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _d === void 0 ? void 0 : _d.nrinonnri, nrinonnriid: (_e = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _e === void 0 ? void 0 : _e.nrinonnriid, country: (_f = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _f === void 0 ? void 0 : _f.country, countryprefix: (_g = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _g === void 0 ? void 0 : _g.countryprefix, countryshortcode: (_h = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _h === void 0 ? void 0 : _h.countryshortcode, isfocus: uccParams ? false : true, bucketId: bucketIdParams ? Number(bucketIdParams) : l === null || l === void 0 ? void 0 : l.bucketId, bucketName: bucketIdParams
                                    ? leadStatusConfig.accquisitionProductIdObj.name
                                    : l === null || l === void 0 ? void 0 : l.bucketName, productId: productIdParams
                                    ? Number(productIdParams)
                                    : l === null || l === void 0 ? void 0 : l.productId, productName: productIdParams
                                    ? leadStatusConfig.clientAcquisitionName
                                    : l === null || l === void 0 ? void 0 : l.productName, categoryId: categoryIdParams
                                    ? Number(categoryIdParams)
                                    : l === null || l === void 0 ? void 0 : l.categoryId, categoryName: categoryIdParams
                                    ? leadStatusConfig.investmentCategoryName
                                    : l === null || l === void 0 ? void 0 : l.categoryName, primaryproductid: productIdParams
                                    ? Number(productIdParams)
                                    : l === null || l === void 0 ? void 0 : l.primaryproductid, primaryproductName: productIdParams
                                    ? leadStatusConfig.clientAcquisitionName
                                    : l === null || l === void 0 ? void 0 : l.primaryproductName });
                            //Object.assign(l, selectedLead.data);
                        });
                    });
                    if ((_76 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _76 === void 0 ? void 0 : _76.acCode) {
                        if (_leadAccountRef.current &&
                            (((_77 = _leadAccountRef.current) === null || _77 === void 0 ? void 0 : _77.accId) === ((_78 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _78 === void 0 ? void 0 : _78.acCode) ||
                                ((_79 = _leadAccountRef.current) === null || _79 === void 0 ? void 0 : _79.leadId) === ((_80 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _80 === void 0 ? void 0 : _80.leadId))) {
                        }
                        else {
                            getMultipleLeads((_81 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _81 === void 0 ? void 0 : _81.leadId, (_82 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _82 === void 0 ? void 0 : _82.acCode);
                        }
                        _leadAccountRef.current = {
                            accId: (_83 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _83 === void 0 ? void 0 : _83.acCode,
                            leadId: (_84 = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _84 === void 0 ? void 0 : _84.leadId,
                        };
                    }
                }
            }
            setLoader(false);
        }
    }, [selectedLead]);
    useEffect(function () {
        setLeadData(function (lead) {
            return lead === null || lead === void 0 ? void 0 : lead.map(function (l, i) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                return __assign(__assign({}, l), { typeOfContact: (l === null || l === void 0 ? void 0 : l.leadId)
                        ? (l === null || l === void 0 ? void 0 : l.typeOfContact)
                            ? l === null || l === void 0 ? void 0 : l.typeOfContact
                            : (_a = leadData[0]) === null || _a === void 0 ? void 0 : _a.typeOfContact
                        : (_b = leadData[0]) === null || _b === void 0 ? void 0 : _b.typeOfContact, meetingDate: (l === null || l === void 0 ? void 0 : l.leadId)
                        ? (l === null || l === void 0 ? void 0 : l.meetingDate)
                            ? l === null || l === void 0 ? void 0 : l.meetingDate
                            : (_c = leadData[0]) === null || _c === void 0 ? void 0 : _c.meetingDate
                        : (_d = leadData[0]) === null || _d === void 0 ? void 0 : _d.meetingDate, meetingTime: (l === null || l === void 0 ? void 0 : l.leadId)
                        ? (l === null || l === void 0 ? void 0 : l.meetingTime)
                            ? l === null || l === void 0 ? void 0 : l.meetingTime
                            : (_e = leadData[0]) === null || _e === void 0 ? void 0 : _e.meetingTime
                        : (_f = leadData[0]) === null || _f === void 0 ? void 0 : _f.meetingTime, meetingClosureDate: !leadid &&
                        i !== 0 &&
                        (l === null || l === void 0 ? void 0 : l.didMeetingHappend) &&
                        moment("".concat((_g = leadData[0]) === null || _g === void 0 ? void 0 : _g.meetingDate, " ").concat((_h = leadData[0]) === null || _h === void 0 ? void 0 : _h.meetingTime), "YYYY/MM/DD hh:mm") < moment()
                        ? (_j = leadData[0]) === null || _j === void 0 ? void 0 : _j.meetingDate
                        : l === null || l === void 0 ? void 0 : l.meetingClosureDate, meetingClosureTime: !leadid &&
                        i !== 0 &&
                        (l === null || l === void 0 ? void 0 : l.didMeetingHappend) &&
                        moment("".concat((_k = leadData[0]) === null || _k === void 0 ? void 0 : _k.meetingDate, " ").concat((_l = leadData[0]) === null || _l === void 0 ? void 0 : _l.meetingTime), "YYYY/MM/DD hh:mm") < moment()
                        ? (_m = leadData[0]) === null || _m === void 0 ? void 0 : _m.meetingTime
                        : l === null || l === void 0 ? void 0 : l.meetingClosureTime });
                //Object.assign(l, selectedLead.data);
            });
        });
    }, __spreadArray(__spreadArray([], __read((Array.isArray(leadData) && leadData.length > 0
        ? [
            (_a = leadData[0]) === null || _a === void 0 ? void 0 : _a.typeOfContact,
            (_b = leadData[0]) === null || _b === void 0 ? void 0 : _b.meetingDate,
            (_c = leadData[0]) === null || _c === void 0 ? void 0 : _c.meetingTime,
        ]
        : [])), false), [
        refreshPage,
    ], false));
    useEffect(function () {
        if (!!meetingDetailsFormData &&
            (meetingDetailsFormData === null || meetingDetailsFormData === void 0 ? void 0 : meetingDetailsFormData.bucketId) &&
            (meetingDetailsFormData === null || meetingDetailsFormData === void 0 ? void 0 : meetingDetailsFormData.bucketId.toString()) ===
                leadStatusConfig.productBucketId &&
            (meetingDetailsFormData === null || meetingDetailsFormData === void 0 ? void 0 : meetingDetailsFormData.productId) &&
            (meetingDetailsFormData === null || meetingDetailsFormData === void 0 ? void 0 : meetingDetailsFormData.categoryId) &&
            (meetingDetailsFormData === null || meetingDetailsFormData === void 0 ? void 0 : meetingDetailsFormData.currentFocusedProduct) !== null && // These conditions are checked separately because meetingDetailsFormData?.currentFocusedProduct can contain 0 as value and that is required for index accessing array objects.
            (meetingDetailsFormData === null || meetingDetailsFormData === void 0 ? void 0 : meetingDetailsFormData.currentFocusedProduct) !== undefined &&
            meetingDetailsFormData.isCheckedForEdit) {
            getValidationPipelineAmt(meetingDetailsFormData.productId, meetingDetailsFormData.categoryId, meetingDetailsFormData === null || meetingDetailsFormData === void 0 ? void 0 : meetingDetailsFormData.currentFocusedProduct);
        }
    }, [
        meetingDetailsFormData === null || meetingDetailsFormData === void 0 ? void 0 : meetingDetailsFormData.bucketId,
        meetingDetailsFormData === null || meetingDetailsFormData === void 0 ? void 0 : meetingDetailsFormData.productId,
        meetingDetailsFormData === null || meetingDetailsFormData === void 0 ? void 0 : meetingDetailsFormData.categoryId,
    ]);
    useEffect(function () {
        if (!!refreshPage && (refreshPage === null || refreshPage === void 0 ? void 0 : refreshPage.length) > 0 && refreshPage === "Y") {
            setLeadData([initialMeetingObj]);
            setRefreshPageValue(true);
            localStorage.removeItem(ELocalStorageKeys.RefreshPage);
        }
    }, [refreshPage]);
    var pitchIcon = function () { return __awaiter(void 0, void 0, void 0, function () {
        var stopProceedOnPitchProduct, payload, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    stopProceedOnPitchProduct = !(!!meetingDetailsFormData.bucketName &&
                        !!meetingDetailsFormData.categoryName &&
                        !!meetingDetailsFormData.subCategoryName &&
                        !!meetingDetailsFormData.productName);
                    if (!stopProceedOnPitchProduct) return [3 /*break*/, 1];
                    setToastMeetingSelection(true);
                    return [2 /*return*/];
                case 1:
                    if (!leadData) return [3 /*break*/, 3];
                    setEmailPopup(true);
                    payload = leadData.map(function (x) {
                        return {
                            productId: x.productId,
                            categoryId: x.categoryId,
                            subcategoryId: x.subCategoryId,
                        };
                    });
                    return [4 /*yield*/, leadDi.leads.leadsPitchProd(payload)];
                case 2:
                    resp = _a.sent();
                    setLeadPitchProducts(resp);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var captureLeadId = function (isTrue) {
        var _a, _b;
        if (((_a = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _a === void 0 ? void 0 : _a.leadSource) === (leadStatusConfig === null || leadStatusConfig === void 0 ? void 0 : leadStatusConfig.saathiLeadSource) &&
            !((_b = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _b === void 0 ? void 0 : _b.isMobileVerified)) {
            setIsAddNewLead(false);
        }
        else {
            setIsAddNewLead(isTrue);
        }
    };
    var captureLeadIdPartner = function (isTrue) {
        setIsPartnerNewLead(isTrue);
    };
    var removeNewMeetingDetails = function (index) {
        setLeadData(function (_a) {
            var _b = __read(_a), leadData = _b.slice(0);
            if (leadData.length > 0 && index !== 0) {
                leadData.splice(index, 1);
            }
            return leadData;
        });
        var localPipelineValidationData = __spreadArray([], __read(pipelineValidationData), false);
        localPipelineValidationData.splice(index, 1);
        setPipelineValidationData(localPipelineValidationData);
    };
    var scrollToTop = function () {
        document.getElementById("pastintercation-backtotop-main").scrollIntoView({
            block: "start",
            behavior: "smooth",
            inline: "start",
        });
        // scroller.scrollTo("pastintercation-backtotop", {
        //   top: 0,
        //   behavior: "smooth",
        //   offset: -150,
        // });
    };
    var redirectToLeadDashabord = function (leadId) {
        window.open(config.applicationFolder +
            "dashboard/lead-dashboard?searchText=" +
            window.btoa(leadId) +
            "&isView=" +
            "Y", "_blank");
    };
    var setRefreshValue = function () {
        if ((leadid == "" || leadid == undefined || leadid == null) &&
            (partnerOrClient == "" ||
                partnerOrClient == undefined ||
                partnerOrClient == null) &&
            (isParentOrChild == "" ||
                isParentOrChild == undefined ||
                isParentOrChild == null) &&
            (parentLeadId == "" || parentLeadId == undefined || parentLeadId == null)) {
            setRefreshPageValue(true);
        }
        else {
            setRefreshPageValue(false);
        }
    };
    useEffect(function () {
        getLeadPriority();
        localStorage.removeItem("leadData");
        setFromInterestedConvPanChange(false);
        setIsVerifiedPanPopUp(false);
        window.scrollTo(0, 0);
        setRefreshValue();
        var body = document.querySelector("body");
        body.style.overflow = "hidden";
        return function () {
            body.style.overflow = "auto";
        };
    }, []);
    var getChildLeadData = function () {
        var payloads = {
            leadId: leadid,
        };
        di.leads
            .getChildLeadData(payloads)
            .then(function (result) {
            setChildLeadData(result.childData.data);
        })
            .catch(function (error) {
            console.log(error);
        });
    };
    var returnSuccessMsgUIView = function () {
        return (React.createElement(React.Fragment, null, leadIsViewLst && (leadIsViewLst === null || leadIsViewLst === void 0 ? void 0 : leadIsViewLst.length) > 0 ? (leadIsViewLst.map(function (leadRecord) {
            return (React.createElement("span", null,
                !!(leadRecord === null || leadRecord === void 0 ? void 0 : leadRecord.index) ? leadRecord.index + "." : "",
                " ",
                React.createElement("span", { className: (leadRecord === null || leadRecord === void 0 ? void 0 : leadRecord.isView)
                        ? "text-decoration-underline hand_cursor"
                        : "", onClick: function () {
                        var _a;
                        if ((leadRecord === null || leadRecord === void 0 ? void 0 : leadRecord.isView) && ((_a = leadRecord === null || leadRecord === void 0 ? void 0 : leadRecord.leadId) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                            redirectToLeadDashabord(leadRecord === null || leadRecord === void 0 ? void 0 : leadRecord.leadId);
                        }
                    } }, leadRecord === null || leadRecord === void 0 ? void 0 : leadRecord.leadId), leadRecord === null || leadRecord === void 0 ? void 0 :
                leadRecord.description,
                React.createElement("br", null)));
        })) : (React.createElement("span", { dangerouslySetInnerHTML: { __html: successMsg } }))));
    };
    var createNewChildLeadURL = function () {
        var childLeadUrl = config.applicationFolder +
            "dashboard/leadpage/" +
            window.btoa(null) +
            "/" +
            window.btoa(String(true)) +
            "/" +
            window.btoa(String(true)) +
            "/" +
            window.btoa(leadid);
        di.leads
            .editAccessLead({
            strLeadId: leadid,
            strFlag: IEditLeadAccessPayloadEnum.SPLIT_FLAG,
        })
            .then(function (resp) {
            if (resp.response) {
                //   showEditObj.showEditLoader=false;
                setEditAccessUiState(function (editAccessUiState) {
                    editAccessUiState.isEditAccessLoader = false;
                    return editAccessUiState;
                });
                window.open(childLeadUrl, "_blank");
            }
            else {
                //showEditObj.showEditLoader=false;
                setEditAccessUiState(function (editAccessUiState) {
                    editAccessUiState.editAccessMsg = resp.responseDescription;
                    editAccessUiState.isEditAccessErrorState = true;
                    editAccessUiState.isEditAccessLoader = false;
                    return editAccessUiState;
                });
                setEditAccessToast(true);
            }
        })
            .catch(function (error) {
            // showEditObj.showEdit = false;
            setEditAccessToast(true);
            setEditAccessUiState(function (editAccessUiState) {
                editAccessUiState.editAccessMsg =
                    "Something went wrong.please try again later";
                editAccessUiState.isEditAccessErrorState = true;
                editAccessUiState.isEditAccessLoader = false;
                return editAccessUiState;
            });
        });
    };
    var parentLeadDetailsCol = [
        {
            title: "Partner Lead ID",
            value: ((_d = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _d === void 0 ? void 0 : _d.parentLeadId)
                ? (_e = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _e === void 0 ? void 0 : _e.parentLeadId
                : parentLeadId,
        },
        { title: "Partner Name", value: (_f = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _f === void 0 ? void 0 : _f.partnerName },
        { title: "Pipeline", value: (_g = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _g === void 0 ? void 0 : _g.amount },
        {
            title: "Remaining Pipeline",
            value: (_h = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _h === void 0 ? void 0 : _h.pendingpipelinevalue,
        },
        { title: "Product", value: (_j = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _j === void 0 ? void 0 : _j.productName },
        { title: "Category", value: (_k = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _k === void 0 ? void 0 : _k.categoryName },
        { title: "Sub Category", value: (_l = parentLeadObj === null || parentLeadObj === void 0 ? void 0 : parentLeadObj.data) === null || _l === void 0 ? void 0 : _l.displayName },
    ];
    var updateExpiringLeadCount = function () {
        var req = {
            page: "1",
            pageSize: "100",
        };
        homeDI.home.getExpiringLeads(req);
    };
    var checkCommentValidation = function (localLeadData) {
        return localLeadData === null || localLeadData === void 0 ? void 0 : localLeadData.every(function (meetingdetails) {
            var _a, _b;
            var isCommentMandetory = (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.didMeetingHappend) || !!(meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.followupModeId);
            return ((isCommentMandetory &&
                meetingdetails.notes.length >=
                    (addEditLeadConstants === null || addEditLeadConstants === void 0 ? void 0 : addEditLeadConstants.INTERNAL_COMMENT_MIN_LENGTH)) ||
                (!isCommentMandetory &&
                    (((_a = meetingdetails.notes) === null || _a === void 0 ? void 0 : _a.length) >=
                        (addEditLeadConstants === null || addEditLeadConstants === void 0 ? void 0 : addEditLeadConstants.INTERNAL_COMMENT_MIN_LENGTH) ||
                        ((_b = meetingdetails.notes) === null || _b === void 0 ? void 0 : _b.length) === 0)));
        });
    };
    var submitHandler = function () {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
        setSubmitLoader(true);
        if (meetingRef) {
            meetingRef === null || meetingRef === void 0 ? void 0 : meetingRef.current.updateParentState();
        }
        // if (!leadData[0].sourceId) {
        //   setError((err: INewLeadinput) => {
        //     return {
        //       ...err,
        //       sourceName: "This field is Required.",
        //     };
        //   });
        //   return;
        // }
        // if (!leadData[0].subSourceId) {
        //   setError((err: INewLeadinput) => {
        //     return {
        //       ...err,
        //       subSourceName: "This field is Required.",
        //     };
        //   });
        //   return;
        // }
        if (!leadData[0].firstName &&
            (!leadData[0].acCode || !leadData[0].leadId)) {
            setError(function (err) {
                return __assign(__assign({}, err), { searchclient: "This field is Required." });
            });
            setSubmitLoader(false);
            return;
        }
        var localLeadData = leadData;
        leadData === null || leadData === void 0 ? void 0 : leadData.some(function (item) {
            if (item === null || item === void 0 ? void 0 : item.isClient) {
                localLeadData = leadData === null || leadData === void 0 ? void 0 : leadData.filter(function (lead) { return lead.isCheckedForEdit === true; });
                return true;
            }
            return false;
        });
        var momParticipantError = false;
        var closureMonthError = false;
        if (checkPipelineAmountValidation() &&
            checkCommentValidation(localLeadData) &&
            checkPanIsValid(localLeadData)) {
            if (localLeadData && localLeadData.length > 0) {
                localLeadData = localLeadData.map(function (record) {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    delete record.currentFocusedProduct;
                    if (record.interaction_sub_statusid ===
                        Number(leadStatusConfig.followupSubInteractionStatusId) &&
                        moment(record === null || record === void 0 ? void 0 : record.meetingFollowUpDate).isAfter(moment(record === null || record === void 0 ? void 0 : record.closuremonth), "month")) {
                        closureMonthError = true;
                        return record;
                    }
                    if ((record === null || record === void 0 ? void 0 : record.dob) !== null &&
                        (record === null || record === void 0 ? void 0 : record.dob) !== undefined &&
                        (record === null || record === void 0 ? void 0 : record.dob) !== "") {
                        record.dob = moment(record === null || record === void 0 ? void 0 : record.dob, "DD/MM/YYYY").format("YYYY-MM-DD");
                    }
                    if ((record === null || record === void 0 ? void 0 : record.subStatusId) ===
                        Number(leadStatusConfig.interestedInteractionStatusId) &&
                        (record === null || record === void 0 ? void 0 : record.interaction_sub_statusid) ===
                            Number(leadStatusConfig.convertedInteractionSubStatusId) &&
                        ((record === null || record === void 0 ? void 0 : record.EntityType) === "" ||
                            (record === null || record === void 0 ? void 0 : record.EntityType) === null ||
                            (record === null || record === void 0 ? void 0 : record.EntityType) === undefined)) {
                        if (record.pan && ((_a = record.pan) === null || _a === void 0 ? void 0 : _a.length) > 0 && record.pan[3] !== "P") {
                            record.EntityType =
                                (_b = leadStatusConfig === null || leadStatusConfig === void 0 ? void 0 : leadStatusConfig.nonIndividualEntityTypeObj) === null || _b === void 0 ? void 0 : _b.name;
                            record.EntityTypeId =
                                (_c = leadStatusConfig === null || leadStatusConfig === void 0 ? void 0 : leadStatusConfig.nonIndividualEntityTypeObj) === null || _c === void 0 ? void 0 : _c.id;
                        }
                        else {
                            if (record.pan &&
                                ((_d = record.pan) === null || _d === void 0 ? void 0 : _d.length) > 0 &&
                                record.pan[3] === "P") {
                                record.EntityType =
                                    (_e = leadStatusConfig === null || leadStatusConfig === void 0 ? void 0 : leadStatusConfig.individualEntityTypeObj) === null || _e === void 0 ? void 0 : _e.name;
                                record.EntityTypeId =
                                    (_f = leadStatusConfig === null || leadStatusConfig === void 0 ? void 0 : leadStatusConfig.individualEntityTypeObj) === null || _f === void 0 ? void 0 : _f.id;
                            }
                        }
                        //  checkPanDedupeValue = checkPanDedupe(record);
                    }
                    if (record.productId === ((_g = leadStatusConfig === null || leadStatusConfig === void 0 ? void 0 : leadStatusConfig.investmentProductIdObj) === null || _g === void 0 ? void 0 : _g.id)) {
                        record.subCategoryId = 0;
                        record.subCategoryName = "";
                    }
                    if (record.amount === "" ||
                        record.amount === null ||
                        record.amount === undefined) {
                        record.amount = "0";
                    }
                    if (showHideForLoginType().requestPayloadIsParentFlag) {
                        record.isClient = false;
                        if (record.bucketId === Number(leadStatusConfig.productBucketId)) {
                            record.isParent = true;
                        }
                        else {
                            record.isParent = false;
                        }
                    }
                    if (record.isCheckedForEdit &&
                        (record === null || record === void 0 ? void 0 : record.didMeetingHappend) &&
                        momView &&
                        ((record === null || record === void 0 ? void 0 : record.bucketId) === parseInt(leadStatusConfig.productBucketId) ||
                            (record === null || record === void 0 ? void 0 : record.bucketId) ===
                                parseInt(leadStatusConfig.accquisitionProductIdObj.id))) {
                        record.isSentMOM = "Yes";
                        record.momIsExpert = momFormData === null || momFormData === void 0 ? void 0 : momFormData.momIsExpert;
                        record.momParticipants = momFormData === null || momFormData === void 0 ? void 0 : momFormData.momParticipants;
                        record.momIsPortfolioSln = momFormData === null || momFormData === void 0 ? void 0 : momFormData.momIsPortfolioSln;
                        record.momIsAOP = momFormData === null || momFormData === void 0 ? void 0 : momFormData.momIsAOP;
                        if ((((_h = momFormData === null || momFormData === void 0 ? void 0 : momFormData.momParticipants) === null || _h === void 0 ? void 0 : _h.length) === 0 ||
                            !(momFormData === null || momFormData === void 0 ? void 0 : momFormData.momParticipants)) &&
                            (momFormData === null || momFormData === void 0 ? void 0 : momFormData.momIsExpert) === "Yes") {
                            momParticipantError = true;
                            setMomParticipantsError(true);
                        }
                        else {
                            setMomParticipantsError(false);
                        }
                    }
                    return record;
                });
                if (momParticipantError || closureMonthError) {
                    setSubmitLoader(false);
                    return;
                }
                if (leadid && partnerOrClientValue === false) {
                    localLeadData = localLeadData.map(function (record) {
                        if (record.bucketId === Number(leadStatusConfig.productBucketId)) {
                            record.isParent = true;
                        }
                        else {
                            record.isParent = false;
                        }
                        return record;
                    });
                }
            }
            leadDi.leads
                .saveLead(localLeadData)
                .then(function (result) {
                var _a, _b, _c;
                setSubmitLoader(false);
                // let msg: string = "";
                // result.map((x, i) => {
                //   msg += `\n${i + 1}. ${x.leadId} ${x.responseDescription}`;
                // });
                var sendMOM = localLeadData === null || localLeadData === void 0 ? void 0 : localLeadData.some(function (leadItem) { return (leadItem === null || leadItem === void 0 ? void 0 : leadItem.isSentMOM) === "Yes"; });
                result.some(function (item) {
                    if ((item === null || item === void 0 ? void 0 : item.response) === "Success" && !!(item === null || item === void 0 ? void 0 : item.meetingId) && sendMOM) {
                        if (isMoMEdited) {
                            editMomTemplate(item === null || item === void 0 ? void 0 : item.meetingId);
                        }
                        else {
                            getMomTemplateView("EMAIL", item === null || item === void 0 ? void 0 : item.meetingId);
                        }
                        return true;
                    }
                    return false;
                });
                updateExpiringLeadCount();
                if (result.every(function (x) { return x.response === "Success"; })) {
                    var msg_1 = "";
                    result.map(function (x, i) {
                        msg_1 +=
                            "\n".concat(i + 1, ". ").concat(x.leadId, " ").concat(x.responseDescription) + "</br>";
                    });
                    setLeadIsViewLst([]);
                    var params = (_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.param;
                    var leadTableTab = (_c = (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.leadTableTab) !== null && _c !== void 0 ? _c : 0;
                    navigate("/dashboard/lead-dashboard" + "".concat(params ? "?" + params : ""), {
                        state: {
                            show: true,
                            iamBack: true,
                            leadTableTab: leadTableTab,
                            msg: msg_1,
                        },
                    });
                }
                else {
                    var msg = "", leadViewLeadIdLst_1 = [];
                    result.map(function (x, i) {
                        leadViewLeadIdLst_1.push({
                            isView: x === null || x === void 0 ? void 0 : x.isView,
                            leadId: x === null || x === void 0 ? void 0 : x.leadId,
                            index: i + 1,
                            description: x === null || x === void 0 ? void 0 : x.responseDescription,
                        });
                    });
                    if ((leadViewLeadIdLst_1 === null || leadViewLeadIdLst_1 === void 0 ? void 0 : leadViewLeadIdLst_1.length) > 0) {
                        setLeadIsViewLst(leadViewLeadIdLst_1);
                    }
                    setIsError(true);
                    setShowSuccess(true);
                    //    setSuccessStageOpen(msg);
                }
                // setLeadData([initMeetingData]);
                // setSelectedLead({ data: undefined });
            })
                .catch(function (error) {
                setIsError(true);
                setSubmitLoader(false);
                setSuccessStageOpen("Failed to update Lead." + (error === null || error === void 0 ? void 0 : error.getMessage()));
            });
        }
        else {
            setSubmitLoader(false);
        }
    };
    var checkPanIsValid = function (leadData) {
        var isPanError = panError.some(function (err) { return err.panError; });
        if (isPanError)
            return false;
        if (leadData && (leadData === null || leadData === void 0 ? void 0 : leadData.length) > 0) {
            return leadData === null || leadData === void 0 ? void 0 : leadData.every(function (meetingdetails, idx) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                if (!(((_a = meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.bucketId) === null || _a === void 0 ? void 0 : _a.toString()) ===
                    leadStatusConfig.productBucketId &&
                    (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.didMeetingHappend) &&
                    getPanAllowedFoundObj(meetingdetails.categoryId, idx) !== null &&
                    ((_b = getPanAllowedFoundObj(meetingdetails.categoryId, idx)) === null || _b === void 0 ? void 0 : _b.panMandate) &&
                    (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.subStatusId) ===
                        Number(leadStatusConfig.interestedInteractionStatusId) &&
                    (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.interaction_sub_statusid) ===
                        Number(leadStatusConfig.convertedInteractionSubStatusId))) {
                    if ((meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.sbPassout) !== null &&
                        (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.sbPassout) !== undefined &&
                        ((meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.sbPassout) < 0 || (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.sbPassout) > 100)) {
                        return false;
                    }
                    else {
                        return true;
                    }
                }
                else {
                    if (getPanAllowedFoundObj(meetingdetails.categoryId, idx) !== null &&
                        ((_c = getPanAllowedFoundObj(meetingdetails.categoryId, idx)) === null || _c === void 0 ? void 0 : _c.panMandate)) {
                        if (((_d = meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.pan) === null || _d === void 0 ? void 0 : _d.length) > 0 &&
                            ((_e = meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.bucketId) === null || _e === void 0 ? void 0 : _e.toString()) ===
                                leadStatusConfig.productBucketId &&
                            (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.didMeetingHappend) &&
                            (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.subStatusId) ===
                                Number(leadStatusConfig.interestedInteractionStatusId) &&
                            (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.interaction_sub_statusid) ===
                                Number(leadStatusConfig.convertedInteractionSubStatusId) &&
                            (pan === null || pan === void 0 ? void 0 : pan.test(meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.pan)) &&
                            alphaNumExp.test(meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.pan) &&
                            ((panError && ((_f = panError[idx]) === null || _f === void 0 ? void 0 : _f.panError) === false) ||
                                (panError === null || panError === void 0 ? void 0 : panError.length) == 0 ||
                                (panError &&
                                    !((_g = panError[idx]) === null || _g === void 0 ? void 0 : _g.panError) &&
                                    panError[idx].message === ""))) {
                            if ((meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.sbPassout) !== null &&
                                (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.sbPassout) !== undefined &&
                                ((meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.sbPassout) < 0 ||
                                    (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.sbPassout) > 100)) {
                                return false;
                            }
                            else {
                                if ((panError && ((_h = panError[idx]) === null || _h === void 0 ? void 0 : _h.panError) === false) ||
                                    (panError === null || panError === void 0 ? void 0 : panError.length) == 0 ||
                                    (panError &&
                                        !((_j = panError[idx]) === null || _j === void 0 ? void 0 : _j.panError) &&
                                        panError[idx].message === "")) {
                                    return true;
                                }
                                else
                                    return false;
                            }
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        if ((meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.pan) == null ||
                            (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.pan) == undefined ||
                            (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.pan) == "") {
                            if ((meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.sbPassout) !== null &&
                                (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.sbPassout) !== undefined &&
                                ((meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.sbPassout) < 0 ||
                                    (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.sbPassout) > 100)) {
                                return false;
                            }
                            else {
                                return true;
                            }
                        }
                        else if ((meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.pan) !== null &&
                            (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.pan) !== undefined &&
                            (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.pan) !== "" &&
                            ((_k = meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.pan) === null || _k === void 0 ? void 0 : _k.length) > 0 &&
                            ((_l = meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.bucketId) === null || _l === void 0 ? void 0 : _l.toString()) ===
                                leadStatusConfig.productBucketId &&
                            (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.didMeetingHappend) &&
                            (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.subStatusId) ===
                                Number(leadStatusConfig.interestedInteractionStatusId) &&
                            (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.interaction_sub_statusid) ===
                                Number(leadStatusConfig.convertedInteractionSubStatusId) &&
                            (pan === null || pan === void 0 ? void 0 : pan.test(meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.pan)) &&
                            alphaNumExp.test(meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.pan) &&
                            ((panError && ((_m = panError[idx]) === null || _m === void 0 ? void 0 : _m.panError) === false) ||
                                (panError === null || panError === void 0 ? void 0 : panError.length) == 0)) {
                            if ((meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.sbPassout) !== null &&
                                (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.sbPassout) !== undefined &&
                                ((meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.sbPassout) < 0 ||
                                    (meetingdetails === null || meetingdetails === void 0 ? void 0 : meetingdetails.sbPassout) > 100)) {
                                return false;
                            }
                            else {
                                return true;
                            }
                        }
                        else {
                            return false;
                        }
                    }
                }
            });
        }
        else {
            return false;
        }
    };
    var getPanAllowedFoundObj = function (categoryId, index) {
        if (panIsMandatory && (panIsMandatory === null || panIsMandatory === void 0 ? void 0 : panIsMandatory.length) > 0)
            return panIsMandatory.find(function (panRecord) {
                return (panRecord === null || panRecord === void 0 ? void 0 : panRecord.categoryId) === categoryId && (panRecord === null || panRecord === void 0 ? void 0 : panRecord.index) == index;
            });
        else {
            return null;
        }
    };
    var checkPipelineAmountValidation = function () {
        var pipelineElements = document.querySelectorAll("#amount");
        var flag = leadData.every(function (item, index) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            if (item.isCheckedForEdit) {
                if ((item === null || item === void 0 ? void 0 : item.interaction_sub_statusid) ===
                    Number(leadStatusConfig.convertedInteractionSubStatusId) &&
                    item.bucketId == leadStatusConfig.productBucketId) {
                    return ((_b = (_a = pipelineValidationData[index]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.min_pipeline_val)
                        ? !!item.amount &&
                            Number(item.amount) > 0 &&
                            Number(item.amount) >=
                                ((_d = (_c = pipelineValidationData[index]) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.min_pipeline_val)
                            ? true
                            : false
                        : !!item.amount && Number(item.amount) > 0
                            ? true
                            : false;
                }
                else {
                    if (((_e = pipelineValidationData[index]) === null || _e === void 0 ? void 0 : _e.isPipelineAdded) &&
                        ((_g = (_f = pipelineValidationData[index]) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.min_pipeline_val)) {
                        if (!!item.amount &&
                            Number(item.amount) > 0 &&
                            Number(item.amount) >=
                                ((_j = (_h = pipelineValidationData[index]) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.min_pipeline_val)) {
                            return true;
                        }
                        else {
                            var localData = __spreadArray([], __read(pipelineValidationData), false);
                            localData[index].isPipelineAdded = true;
                            localData[index].isShowError = true;
                            setPipelineValidationData(localData);
                            return false;
                        }
                    }
                    else
                        return true;
                }
            }
            return true;
        });
        if (pipelineElements.length) {
            var index_1 = -1;
            var temp = Array.from(pipelineElements);
            temp.every(function (item, idx) {
                var _a;
                if (((_a = item === null || item === void 0 ? void 0 : item.previousElementSibling) === null || _a === void 0 ? void 0 : _a.className) === " error") {
                    index_1 = idx;
                    return false;
                }
                else
                    return true;
            });
            if (index_1 > -1) {
                pipelineElements[index_1].scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }
        }
        return flag;
    };
    var getleadProductDetails = function (currentMeetingData) {
        if ((currentMeetingData === null || currentMeetingData === void 0 ? void 0 : currentMeetingData.productId) === productsId.fixedIncome ||
            (currentMeetingData === null || currentMeetingData === void 0 ? void 0 : currentMeetingData.categoryId) ===
                productsId.structuredProductsCategoryId ||
            (currentMeetingData === null || currentMeetingData === void 0 ? void 0 : currentMeetingData.categoryId) === productsId.mutualFundCategoryId) {
            return (currentMeetingData === null || currentMeetingData === void 0 ? void 0 : currentMeetingData.issuerId)
                ? (currentMeetingData === null || currentMeetingData === void 0 ? void 0 : currentMeetingData.categoryName) +
                    " - " +
                    (currentMeetingData === null || currentMeetingData === void 0 ? void 0 : currentMeetingData.issuerName)
                : currentMeetingData === null || currentMeetingData === void 0 ? void 0 : currentMeetingData.categoryName;
        }
        else if ((currentMeetingData === null || currentMeetingData === void 0 ? void 0 : currentMeetingData.categoryId) === productsId.aifCategoryId ||
            (currentMeetingData === null || currentMeetingData === void 0 ? void 0 : currentMeetingData.categoryId) === productsId.pmsCategoryId) {
            return (currentMeetingData === null || currentMeetingData === void 0 ? void 0 : currentMeetingData.displayName)
                ? (currentMeetingData === null || currentMeetingData === void 0 ? void 0 : currentMeetingData.categoryName) +
                    " - " +
                    (currentMeetingData === null || currentMeetingData === void 0 ? void 0 : currentMeetingData.displayName)
                : currentMeetingData === null || currentMeetingData === void 0 ? void 0 : currentMeetingData.categoryName;
        }
        else if ((currentMeetingData === null || currentMeetingData === void 0 ? void 0 : currentMeetingData.productId) === productsId.lifeInsurance) {
            return (currentMeetingData === null || currentMeetingData === void 0 ? void 0 : currentMeetingData.displayName)
                ? (currentMeetingData === null || currentMeetingData === void 0 ? void 0 : currentMeetingData.productName) +
                    " - " +
                    (currentMeetingData === null || currentMeetingData === void 0 ? void 0 : currentMeetingData.displayName)
                : currentMeetingData === null || currentMeetingData === void 0 ? void 0 : currentMeetingData.productName;
        }
        else {
            return currentMeetingData === null || currentMeetingData === void 0 ? void 0 : currentMeetingData.categoryName;
        }
    };
    var removeDuplicateString = function (str) {
        if (str.length > 0) {
            var wordsArray = str.split(",").map(function (word) { return word.trim(); });
            var uniqueWords_1 = [];
            wordsArray.forEach(function (word) {
                if (!uniqueWords_1.includes(word)) {
                    uniqueWords_1.push(word);
                }
            });
            return uniqueWords_1.join(", ");
        }
        else {
            return str;
        }
    };
    var getMomTemplateView = function (action, meetingID) {
        var _a;
        if (action === void 0) { action = "VIEW"; }
        setMomTemplateloader(true);
        var payload = {
            envtype: config.envName,
            momAction: action,
            meetingId: meetingID ? meetingID : "",
            clientId: (_a = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _a === void 0 ? void 0 : _a.acCode,
            meetingDoneDate: (momFormData === null || momFormData === void 0 ? void 0 : momFormData.meetingDate) ? momFormData === null || momFormData === void 0 ? void 0 : momFormData.meetingDate : "",
            MeetingDoneTime: (momFormData === null || momFormData === void 0 ? void 0 : momFormData.meetingTime) ? momFormData === null || momFormData === void 0 ? void 0 : momFormData.meetingTime : "",
            meetingFollowupDate: (momFormData === null || momFormData === void 0 ? void 0 : momFormData.followUpDate)
                ? momFormData === null || momFormData === void 0 ? void 0 : momFormData.followUpDate
                : "",
            MeetingFollowupTime: (momFormData === null || momFormData === void 0 ? void 0 : momFormData.followUpTime)
                ? momFormData === null || momFormData === void 0 ? void 0 : momFormData.followUpTime
                : "",
            momProducts: removeDuplicateString(momFormData === null || momFormData === void 0 ? void 0 : momFormData.momProducts),
            MOMProductsWhatsapp: removeDuplicateString(momFormData === null || momFormData === void 0 ? void 0 : momFormData.momProducts),
            momIsExpert: momFormData === null || momFormData === void 0 ? void 0 : momFormData.momIsExpert,
            momParticipants: momFormData === null || momFormData === void 0 ? void 0 : momFormData.momParticipants,
            momIsPortfolioSln: momFormData === null || momFormData === void 0 ? void 0 : momFormData.momIsPortfolioSln,
            momIsAOP: momFormData === null || momFormData === void 0 ? void 0 : momFormData.momIsAOP,
            isNotInterestedLeads: "",
            isFollowupLeads: "",
            isConvertedLeads: "",
            isAcqConverted: "",
            isAcqFollowup: "",
            isAcqNotConverted: "",
            attachments: selectedAttachfile === null || selectedAttachfile === void 0 ? void 0 : selectedAttachfile.map(function (file) { return ({
                etag: file === null || file === void 0 ? void 0 : file.eTag,
                filename: file === null || file === void 0 ? void 0 : file.fileName,
            }); }),
        };
        // no product bucket should present and atleast one accquisiton bucket should present for isAcqleads
        var hasAcquisitionBucket = false;
        var hasProductBucket = leadData === null || leadData === void 0 ? void 0 : leadData.some(function (item) {
            return (item === null || item === void 0 ? void 0 : item.bucketId) === parseInt(leadStatusConfig.productBucketId) &&
                !!(item === null || item === void 0 ? void 0 : item.isCheckedForEdit) &&
                !!(item === null || item === void 0 ? void 0 : item.didMeetingHappend);
        });
        if (!hasProductBucket) {
            hasAcquisitionBucket = leadData === null || leadData === void 0 ? void 0 : leadData.some(function (item) {
                return (item === null || item === void 0 ? void 0 : item.bucketId) ===
                    parseInt(leadStatusConfig.accquisitionProductIdObj.id) &&
                    !!(item === null || item === void 0 ? void 0 : item.isCheckedForEdit) &&
                    !!(item === null || item === void 0 ? void 0 : item.didMeetingHappend);
            });
        }
        payload.isAcqleads = hasAcquisitionBucket ? "Yes" : "No";
        leadData === null || leadData === void 0 ? void 0 : leadData.forEach(function (item) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            if (!!(item === null || item === void 0 ? void 0 : item.isCheckedForEdit) &&
                !!(item === null || item === void 0 ? void 0 : item.didMeetingHappend) &&
                ((item === null || item === void 0 ? void 0 : item.bucketId) === parseInt(leadStatusConfig.productBucketId) ||
                    (item === null || item === void 0 ? void 0 : item.bucketId) ===
                        parseInt(leadStatusConfig.accquisitionProductIdObj.id))) {
                if ((item === null || item === void 0 ? void 0 : item.subStatusId) === leadStatusConfig.notInterestedSubStatusId ||
                    (item === null || item === void 0 ? void 0 : item.interaction_sub_statusid) ===
                        parseInt(leadStatusConfig.notConvertedInteractionSubStatusId) ||
                    (item === null || item === void 0 ? void 0 : item.subStatusId) ===
                        parseInt(leadStatusConfig.notCompletedInteractionStatusId)) {
                    if (payload.isAcqleads === "Yes") {
                        var leadStatus = (_a = getleadProductDetails(item)) !== null && _a !== void 0 ? _a : "";
                        if (leadStatus) {
                            if (!((_b = payload.isAcqNotConverted) === null || _b === void 0 ? void 0 : _b.includes(leadStatus))) {
                                payload.isAcqNotConverted += payload.isAcqNotConverted
                                    ? ", ".concat(leadStatus)
                                    : leadStatus;
                            }
                        }
                    }
                    else if ((item === null || item === void 0 ? void 0 : item.bucketId) === parseInt(leadStatusConfig.productBucketId)) {
                        var leadStatus = (_c = getleadProductDetails(item)) !== null && _c !== void 0 ? _c : "";
                        if (leadStatus) {
                            var statuses = leadStatus
                                .split(",")
                                .map(function (status) { return status.trim(); });
                            statuses.forEach(function (status) {
                                var _a;
                                if (status &&
                                    !((_a = payload.isNotInterestedLeads) === null || _a === void 0 ? void 0 : _a.split(",").map(function (s) { return s.trim(); }).includes(status))) {
                                    payload.isNotInterestedLeads += payload.isNotInterestedLeads
                                        ? ", ".concat(status)
                                        : status;
                                }
                            });
                        }
                    }
                }
                if ((item === null || item === void 0 ? void 0 : item.subStatusId) ===
                    parseInt(leadStatusConfig.followupInteractionStatusId) ||
                    (item === null || item === void 0 ? void 0 : item.interaction_sub_statusid) ===
                        parseInt(leadStatusConfig.followupSubInteractionStatusId)) {
                    if (payload.isAcqleads === "Yes") {
                        var leadStatus = (_d = getleadProductDetails(item)) !== null && _d !== void 0 ? _d : "";
                        if (leadStatus) {
                            if (!((_e = payload.isAcqFollowup) === null || _e === void 0 ? void 0 : _e.includes(leadStatus))) {
                                payload.isAcqFollowup += payload.isAcqFollowup
                                    ? ", ".concat(leadStatus)
                                    : leadStatus;
                            }
                        }
                    }
                    else if ((item === null || item === void 0 ? void 0 : item.bucketId) === parseInt(leadStatusConfig.productBucketId)) {
                        var leadStatus = (_f = getleadProductDetails(item)) !== null && _f !== void 0 ? _f : "";
                        if (leadStatus) {
                            var statuses = leadStatus
                                .split(",")
                                .map(function (status) { return status.trim(); });
                            statuses.forEach(function (status) {
                                var _a;
                                if (status &&
                                    !((_a = payload.isFollowupLeads) === null || _a === void 0 ? void 0 : _a.split(",").map(function (s) { return s.trim(); }).includes(status))) {
                                    payload.isFollowupLeads += payload.isFollowupLeads
                                        ? ", ".concat(status)
                                        : status;
                                }
                            });
                        }
                    }
                }
                if ((item === null || item === void 0 ? void 0 : item.interaction_sub_statusid) ===
                    parseInt(leadStatusConfig.convertedInteractionSubStatusId) ||
                    (item === null || item === void 0 ? void 0 : item.subStatusId) ===
                        parseInt(leadStatusConfig.completedInteractionStatusId)) {
                    if (payload.isAcqleads === "Yes") {
                        var leadStatus = (_g = getleadProductDetails(item)) !== null && _g !== void 0 ? _g : "";
                        if (leadStatus) {
                            if (!((_h = payload.isAcqConverted) === null || _h === void 0 ? void 0 : _h.includes(leadStatus))) {
                                payload.isAcqConverted += payload.isAcqConverted
                                    ? ", ".concat(leadStatus)
                                    : leadStatus;
                            }
                        }
                    }
                    else if ((item === null || item === void 0 ? void 0 : item.bucketId) === parseInt(leadStatusConfig.productBucketId)) {
                        var leadStatus = (_j = getleadProductDetails(item)) !== null && _j !== void 0 ? _j : "";
                        if (leadStatus) {
                            var statuses = leadStatus
                                .split(",")
                                .map(function (status) { return status.trim(); });
                            statuses.forEach(function (status) {
                                var _a;
                                if (status &&
                                    !((_a = payload.isConvertedLeads) === null || _a === void 0 ? void 0 : _a.split(",").map(function (s) { return s.trim(); }).includes(status))) {
                                    payload.isConvertedLeads += payload.isConvertedLeads
                                        ? ", ".concat(status)
                                        : status;
                                }
                            });
                        }
                    }
                }
            }
        });
        leadDi.leads
            .sendViewMomTemplate(payload)
            .then(function (resp) {
            var _a;
            setEmailTemplateResp(resp === null || resp === void 0 ? void 0 : resp.data);
            setEditableMomText((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.momResult);
            setMomTemplateloader(false);
        })
            .catch(function () {
            setMomTemplateloader(false);
        });
    };
    var onFocusProductToggleChange = function (individualMeetingData, isFocus, id) {
        var _a, _b;
        if (!!(individualMeetingData === null || individualMeetingData === void 0 ? void 0 : individualMeetingData.leadId)) {
            if ((((_a = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _a === void 0 ? void 0 : _a.displayNameId) === 0 ||
                ((_b = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _b === void 0 ? void 0 : _b.displayNameId) === null) &&
                (individualMeetingData === null || individualMeetingData === void 0 ? void 0 : individualMeetingData.bucketId) ===
                    parseInt(leadStatusConfig.productBucketId)) {
                validateFocus(individualMeetingData, isFocus, id);
            }
            else {
                setLeadData(function (prev) {
                    var updatedData = prev;
                    updatedData[id] = __assign(__assign({}, updatedData[id]), { isfocus: isFocus });
                    return __spreadArray([], __read(updatedData), false);
                });
            }
        }
        else if (!!(individualMeetingData === null || individualMeetingData === void 0 ? void 0 : individualMeetingData.parentLeadId)) {
            setLeadData(function (prev) {
                var updatedData = prev;
                updatedData[id] = __assign(__assign({}, updatedData[id]), { isfocus: isFocus });
                return __spreadArray([], __read(updatedData), false);
            });
        }
        else {
            setLeadData(function (prev) {
                var updatedData = __spreadArray([], __read(prev), false);
                updatedData[id] = __assign(__assign({}, updatedData[id]), { bucketId: undefined, bucketName: "", productId: undefined, productName: "", categoryId: undefined, categoryName: "", subCategoryId: undefined, subCategoryName: "", subStatusId: undefined, displayNameId: undefined, displayName: "", issuerId: undefined, issuerName: "", isfocus: isFocus });
                return updatedData;
            });
        }
    };
    var validateFocus = function (individualMeetingData, isFocus, id) {
        filterDi.filter
            .validateFocus({
            bucketId: individualMeetingData === null || individualMeetingData === void 0 ? void 0 : individualMeetingData.bucketId,
            productId: individualMeetingData === null || individualMeetingData === void 0 ? void 0 : individualMeetingData.productId,
            categoryId: individualMeetingData === null || individualMeetingData === void 0 ? void 0 : individualMeetingData.categoryId,
        })
            .then(function (resp) {
            var focus = false;
            if (resp === null || resp === void 0 ? void 0 : resp.data) {
                focus = isFocus;
            }
            setLeadData(function (prev) {
                var _a, _b;
                var updatedData = __spreadArray([], __read(prev), false);
                updatedData[id] = __assign(__assign({}, updatedData[id]), { displayNameId: undefined, displayName: "", issuerId: (_a = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _a === void 0 ? void 0 : _a.issuerId, issuerName: (_b = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _b === void 0 ? void 0 : _b.issuerName, isfocus: focus });
                return updatedData;
            });
        })
            .catch(function () { });
    };
    var editMomTemplate = function (meetingID) {
        var _a;
        leadDi.leads.editMomTemplate({
            envtype: config.envName,
            meetingId: meetingID,
            meetingDoneDate: (momFormData === null || momFormData === void 0 ? void 0 : momFormData.meetingDate) ? momFormData === null || momFormData === void 0 ? void 0 : momFormData.meetingDate : "",
            clientId: (_a = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _a === void 0 ? void 0 : _a.acCode,
            htmlcontent: editableMomText,
            attachments: selectedAttachfile === null || selectedAttachfile === void 0 ? void 0 : selectedAttachfile.map(function (file) { return ({
                etag: file === null || file === void 0 ? void 0 : file.eTag,
                filename: file === null || file === void 0 ? void 0 : file.fileName,
            }); }),
        });
    };
    var generateMainComp = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return (React.createElement("div", { className: "new-lead-mainblock", id: "pastintercation-backtotop" },
            (((_a = showHideForLoginType()) === null || _a === void 0 ? void 0 : _a.addParentLeadId) ||
                ((_b = showHideForLoginType()) === null || _b === void 0 ? void 0 : _b.showSubParentSection)) && (React.createElement("div", { className: "bg_white parent-details-block" },
                React.createElement(Row, { className: "DMSan_22_400 txt-midnight-blue " }, "Parent Lead Details"),
                React.createElement(Row, { className: "" }, parentLeadDetailsCol === null || parentLeadDetailsCol === void 0 ? void 0 : parentLeadDetailsCol.map(function (x) { return (React.createElement(Col, null,
                    React.createElement("div", { className: "DMSanN_14_400 txt_primaryGrey mb-2" }, x === null || x === void 0 ? void 0 : x.title),
                    React.createElement("div", { className: "DMSans_16_500 txt_blackOne1" }, (x === null || x === void 0 ? void 0 : x.value) ? x.value : "-"))); })))),
            React.createElement(Accordion, { defaultActiveKey: "main-lead", className: "mgb-15 mgt-36" },
                React.createElement(Accordion.Item, { eventKey: "main-lead" },
                    React.createElement(Accordion.Header, null, leadid ? "Edit Lead" : "Add New Lead"),
                    React.createElement(Accordion.Body, null,
                        React.createElement(NewleadPage, { subSourceReqError: subSourceError, setSubSourceReqError: setSubSourceError, title: leadid ? "Edit Lead" : "Add New Lead", isleadiconblock: true, selectedLead: selectedLead, setSelectedLead: setSelectedLead, setSuccessMsg: setSuccessMsg, LeadId: leadid ||
                                (isAddNewLead && ((_c = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _c === void 0 ? void 0 : _c.leadId)) ||
                                (isPartnerNewLead && ((_d = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _d === void 0 ? void 0 : _d.leadId)), setGlobleDisable: setGlobleDisable, globleDisable: globleDisable, setSuccessStageOpen: setSuccessStageOpen, setLoader: setSubmitLoader, error: error, setError: setError, captureLeadId: captureLeadId, getParentLeadIdDetails: getParentLeadIdDetails, captureLeadIdPartner: captureLeadIdPartner, newClientFlow: setNewClient, newPartnerFlow: setNewPartner, setIsError: setIsError, newLeadPage: leadid ? false : true, setShowSuccess: setShowSuccess, showHideForLoginType: showHideForLoginType, parentLeadObj: parentLeadObj, parentLeadId: parentLeadId, scrollToPastInteractionRef: scrollToPastInteractionRef, updateSubSourceIdForLeadData: updateSubSourceIdForLeadData, setPartnerMainCodeResp: setPartnerMainCodeResp, setClearPan: setClearPan, clientRegister: clientRegister, setClientRegister: setClientRegister, isPartnerRegistration: isPartnerRegistration, setIsPartnerRegistration: setIsPartnerRegistration, fromInterestedConvPanChange: fromInterestedConvPanChange, setFromInterestedConvPanChange: setFromInterestedConvPanChange, notVerifiedLead: notVerifiedLead, setNotVerifiedLead: setNotVerifiedLead, setRefreshPageValue: setRefreshPageValue, refreshPageValue: refreshPageValue, 
                            // setNewClient={setNewClient}
                            panClearOnCancel: panClearOnCancel, panFromInterestedConverted: panFromInterestedConverted, setClearPanForInterestedConverted: setClearPanForInterestedConverted, setLeadData: setLeadData, setMultipleLeadsLoader: setMultipleLeadsLoader, uccParams: uccParams })))),
            showHideForLoginType().showSubChildSection && (React.createElement(Accordion, { className: "mgb-15", defaultActiveKey: "sub-lead" },
                React.createElement(Accordion.Item, { eventKey: "sub-lead" },
                    React.createElement(Accordion.Header, null, "Sub Lead Details"),
                    React.createElement(Accordion.Body, null,
                        React.createElement(SubLeadDetails, { subLeadData: childLeadData, createNewChildLeadURL: createNewChildLeadURL }))))),
            React.createElement("form", { onSubmit: function (e) {
                    e.preventDefault();
                    if (generateErrorMsg().length > 0) {
                        setInterestedPrioritywarning(true);
                    }
                    else {
                        submitHandler();
                    }
                } },
                React.createElement("fieldset", { disabled: globleDisable },
                    submitLoader && React.createElement(Loader, { className: "meeting-details-loader" }),
                    multipleLeadsLoader && React.createElement(LogoLoader, null),
                    !loader && leadData && leadData.length > 0 && (React.createElement("div", { className: "d-flex flex-column gap-3 meeting-product-details-container" }, leadData.map(function (x, i) {
                        var _a, _b, _c, _d, _e, _f;
                        return (React.createElement(Accordion, { defaultActiveKey: (x === null || x === void 0 ? void 0 : x.leadId) ? "0" : i.toString() },
                            React.createElement(Accordion.Item, { eventKey: i.toString() },
                                React.createElement(Accordion.Header, null,
                                    React.createElement("div", { className: "d-flex w-100 justify-content-between align-items-center pe-3" },
                                        React.createElement("div", { className: "d-flex align-items-center gap-4" },
                                            React.createElement("div", { className: "d-flex align-items-center gap-2 form-check" },
                                                selectedTab === ELeadTab.NEW_CLIENT && (React.createElement("input", { className: "meeting-checkbox form-check-input", type: "checkbox", id: "mom-confirmation", onChange: function (e) {
                                                        setLeadData(function (prev) {
                                                            var updatedData = prev;
                                                            updatedData[i] = __assign(__assign({}, updatedData[i]), { isCheckedForEdit: e.target.checked });
                                                            return __spreadArray([], __read(updatedData), false);
                                                        });
                                                    }, checked: x === null || x === void 0 ? void 0 : x.isCheckedForEdit, disabled: (x === null || x === void 0 ? void 0 : x.leadId) ? i === 0 : true, onClick: function (e) {
                                                        e.stopPropagation();
                                                    } })),
                                                React.createElement("span", null, (x === null || x === void 0 ? void 0 : x.leadId) || i === 0
                                                    ? "Meeting Details ".concat(i + 1)
                                                    : "Add New Product details")),
                                            (!(x === null || x === void 0 ? void 0 : x.leadId) ||
                                                (!!(x === null || x === void 0 ? void 0 : x.leadId) &&
                                                    (((_a = multipleSelectedLead === null || multipleSelectedLead === void 0 ? void 0 : multipleSelectedLead.data[i]) === null || _a === void 0 ? void 0 : _a.displayNameId) === 0 ||
                                                        ((_b = multipleSelectedLead === null || multipleSelectedLead === void 0 ? void 0 : multipleSelectedLead.data[i]) === null || _b === void 0 ? void 0 : _b.displayNameId) === null) &&
                                                    (x === null || x === void 0 ? void 0 : x.bucketId) ===
                                                        parseInt(leadStatusConfig.productBucketId)) ||
                                                disableForFocusProduct) && (React.createElement(React.Fragment, null,
                                                React.createElement("span", { className: "seperation border" }),
                                                React.createElement("div", { className: "d-flex align-items-center DMSanN_16_400 focused-product-block" },
                                                    React.createElement(ToggleSwitch, { id: "focusedProduct" + i, name: "focusedProduct" + i, checked: !!(x === null || x === void 0 ? void 0 : x.isfocus), onChange: function (e) {
                                                            onFocusProductToggleChange(x, e, i);
                                                        }, small: true, className: "focused-product-toggle", disabled: disableForFocusProduct }),
                                                    React.createElement("span", { className: " txt_primaryGrey ms-2 me-1 text-nowrap" }, "Focus Products only"),
                                                    React.createElement(GenericTooltip, { placement: "bottom", toolTipText: React.createElement("span", { className: "txt-nickel" },
                                                            React.createElement("span", { className: "DMSanB_12_700 txt-tomato" }, "NEW!"),
                                                            " ",
                                                            "Now plan your sales pipelines with",
                                                            " ",
                                                            React.createElement("span", { className: "DMSanB_12_700" }, "Focus products -"),
                                                            " ",
                                                            "special products with business priority."), triggerType: "hover", toolTipClassName: "focused-product-tooltip", noButton: true, button: React.createElement(Edelicon, { className: "edel-icon-info-2 ", paths: 3 }), externalClassName: "focused-product-icon" }))))),
                                        React.createElement("div", { className: " d-flex align-items-center txt-nuvamaBlue gap-5" },
                                            !!(x === null || x === void 0 ? void 0 : x.productName) &&
                                                selectedTab === ELeadTab.NEW_CLIENT && (React.createElement("span", { className: "bg-ghostWhite txt-nuvamaBlue DMSansNormal_12_400 px-2 py-1 rounded" }, !!(x === null || x === void 0 ? void 0 : x.productName) && !!(x === null || x === void 0 ? void 0 : x.categoryName)
                                                ? "".concat(x === null || x === void 0 ? void 0 : x.productName, " - ").concat(x === null || x === void 0 ? void 0 : x.categoryName)
                                                : "")),
                                            React.createElement("span", { className: " d-flex align-items-center gap-4" },
                                                React.createElement("span", null,
                                                    clickToCallLoader && (React.createElement("div", { className: "loader-box " },
                                                        React.createElement("img", { src: loaderGIF }))),
                                                    !clickToCallLoader &&
                                                        ((_c = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _c === void 0 ? void 0 : _c.leadId) && (React.createElement("div", { className: "d-flex" },
                                                        React.createElement("i", { className: "edel-icon-call1 DMSansNormal_20_400", onClick: function (e) {
                                                                e.stopPropagation();
                                                                clickToCallApi && clickToCallApi();
                                                            } })))),
                                                React.createElement("span", { className: "d-flex" }, !(i === 0 || (x === null || x === void 0 ? void 0 : x.leadId)) && (React.createElement("i", { className: "edel-icon-trash DMSansMedium_16_500", onClick: function (e) {
                                                        e.stopPropagation();
                                                        removeNewMeetingDetails(i);
                                                    } }))))))),
                                React.createElement(Accordion.Body, null,
                                    React.createElement("fieldset", { disabled: (x === null || x === void 0 ? void 0 : x.leadId) && !(x === null || x === void 0 ? void 0 : x.isCheckedForEdit) },
                                        React.createElement(MeetingDetails, { priorityAgeingData: priorityAgeingData, setPriorityDiff: setPriorityDiff, ref: meetingRef, key: i, title: i === 0
                                                ? "Meeting Details"
                                                : "Add New Product details", meetingData: x, setMeetingData: setLeadData, dataUpdateId: i, edited: 
                                            // (leadid && i === 0) || (isAddNewLead && i === 0)
                                            !!(x === null || x === void 0 ? void 0 : x.leadId), setMOM: setEmailPopup, clickToCall: clickToCallApi, selectedLead: ((_d = multipleSelectedLead === null || multipleSelectedLead === void 0 ? void 0 : multipleSelectedLead.data) === null || _d === void 0 ? void 0 : _d.length) > 0
                                                ? {
                                                    data: (multipleSelectedLead === null || multipleSelectedLead === void 0 ? void 0 : multipleSelectedLead.data[i])
                                                        ? __assign({}, multipleSelectedLead === null || multipleSelectedLead === void 0 ? void 0 : multipleSelectedLead.data[i]) : __assign({}, selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data),
                                                }
                                                : selectedLead, setMeetingDetailsFormData: setMeetingDetailsFormData, removeNewMeetingDetails: removeNewMeetingDetails, clickToCallLoader: clickToCallLoader, newLeadPage: leadid || !!(x === null || x === void 0 ? void 0 : x.leadId) ? false : true, newProductAdded: !!leadid || !!(x === null || x === void 0 ? void 0 : x.leadId), showHideForLoginType: showHideForLoginType, parentLeadObj: parentLeadObj, globleDisable: globleDisable, showHideFields: showHideFields, partnerMainCodeResp: partnerMainCodeResp, verifiedPan: verifiedPan, setVerifiedPan: setVerifiedPan, setPanIsMandatory: setPanIsMandatory, panIsMandatory: panIsMandatory, panError: panError, setPanError: setPanError, clearPan: clearPan, setClearPan: setClearPan, clientRegister: clientRegister, setClientRegister: setClientRegister, isPartnerRegistration: isPartnerRegistration, setIsPartnerRegistration: setIsPartnerRegistration, setSuccessStageOpen: setSuccessStageOpen, setIsError: setIsError, setSelectedLead: setSelectedLead, fromInterestedConvPanChange: fromInterestedConvPanChange, setFromInterestedConvPanChange: setFromInterestedConvPanChange, setNotVerifiedLead: setNotVerifiedLead, LeadId: leadid ||
                                                (isAddNewLead && ((_e = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _e === void 0 ? void 0 : _e.leadId)) ||
                                                (isPartnerNewLead && ((_f = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _f === void 0 ? void 0 : _f.leadId)), isVerifiedPanPopUp: isVerifiedPanPopUp, setIsVerifiedPanPopUp: setIsVerifiedPanPopUp, pipelineValidationData: pipelineValidationData, setPipelineValidationData: setPipelineValidationData, getValidationPipelineAmt: getValidationPipelineAmt, panClearOnCancel: panClearOnCancel, meetingDataID: meetingDataID, setMeetingDataID: setMeetingDataID, setClearPanForInterestedConverted: setClearPanForInterestedConverted, clearPanForInterestedConverted: clearPanForInterestedConverted, leadData: leadData, isFromNewClientRegisteration: isAddNewLead, setDoneDateConfirmationPopUp: setDoneDateConfirmationPopUp, schemeIdParams: schemeIdParams }))))));
                    }))),
                    !(((_e = showHideForLoginType()) === null || _e === void 0 ? void 0 : _e.addParentLeadId) ||
                        ((_f = showHideForLoginType()) === null || _f === void 0 ? void 0 : _f.showSubParentSection)) && (React.createElement(Newproduct, { newBtnTitle: "Add New Product", pitchicon: pitchIcon, createNewProduct: addNewProduct, leadData: leadData })),
                    selectedTab === ELeadTab.NEW_CLIENT &&
                        (loginDI.login.getIsRMPartnerFRM().isFRM ||
                            loginDI.login.getIsRMPartnerFRM().isRM) &&
                        !(((_g = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _g === void 0 ? void 0 : _g.isClient) == false) && (React.createElement(MinutesOfMeeting, { partnerMainCodeResp: partnerMainCodeResp, leadData: leadData, selectedLead: selectedLead, emailTemplateResp: emailTemplateResp, getMomTemplateView: getMomTemplateView, setMomFormData: setMomFormData, momFormData: momFormData, momView: momView, setMomView: setMomView, momParticipantsError: momParticipantsError, momTemplateloader: momTemplateloader, leadIdOnParams: leadid, setShowEditableMom: setShowEditableMom, editableMomText: editableMomText, isMoMEdited: isMoMEdited, setIsMoMEdited: setIsMoMEdited, selectedAttachfile: selectedAttachfile, setAttachFilePopUp: setAttachFilePopUp, setEditableMomText: setEditableMomText, setSelectedAttachfile: setSelectedAttachfile }))),
                React.createElement(React.Fragment, null),
                React.createElement("div", { className: "newproduct-button-block" },
                    React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Submit", disabled: globleDisable, type: "submit" }),
                    React.createElement(EdButton, { onClick: function () {
                            var _a, _b, _c;
                            var params = (_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.param;
                            var leadTableTab = (_c = (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.leadTableTab) !== null && _c !== void 0 ? _c : 0;
                            navigate("/dashboard/lead-dashboard" + "".concat(params ? "?" + params : ""), {
                                state: { iamBack: true, leadTableTab: leadTableTab },
                            });
                        }, btnTyp: "midnight-blue-border", disabled: false, value: "Cancel" }))),
            React.createElement(React.Fragment, null, ((_h = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _h === void 0 ? void 0 : _h.id) && (React.createElement(GridContainer, { parentClass: "p-0 past-interaction" },
                React.createElement("div", { className: "DMSan_28_400 txt-midnight-blue my-5", ref: pastInteractionRef },
                    "Past\u00A0",
                    React.createElement("span", { className: "DMSan_28_700 " }, "Interactions")),
                React.createElement(PastIntractionTable, { pastIntraction: leadPastInteractions }),
                React.createElement("div", { className: "accordian-back DMSans_16_500 hand_cursor  txt-midnight-blue d-flex justify-content-end mt-2", onClick: function () { return scrollToTop(); } },
                    React.createElement("i", { className: "edel-icon-arrow-up" }),
                    React.createElement("span", { className: "mgl-10 text-decoration-underline" }, "Back to top"))))),
            interestedPrioritywarning && (React.createElement(SalesWarningPopup, { handleOutsideClick: function () { }, closeDropdown: function () { }, size: "modal-md modal-dialog-centered", icon: "edel-icon-download1", modalTitle: "modalwatchlist commonmodal sales-client lead-warning interested-warning", title: "Confirmation", showFooter: true, show: interestedPrioritywarning, setShow: function () {
                    setInterestedPrioritywarning(false);
                }, showCloseIcon: true, closeicon: "edel-icon-cross", children: React.createElement("div", { className: "DMSans_16_500 txt_primaryGrey line-140" },
                    React.createElement("span", { dangerouslySetInnerHTML: {
                            __html: generateErrorMsg(),
                        } }),
                    "Are you sure you want to submit?"), btnvalueleft: {
                    value: "Yes",
                    btnTyp: "midnight-blue",
                    onClick: function (e) {
                        setInterestedPrioritywarning(false);
                        submitHandler();
                    },
                }, btnvalueright: {
                    value: "No",
                    btnTyp: "midnight-blue-border",
                    onClick: function (e) {
                        setInterestedPrioritywarning(false);
                    },
                } })),
            React.createElement(SalesToasts, { show: showSuccess, setShow: setShowSuccess, position: "middle-center", message: returnSuccessMsgUIView(), isError: isError, parentClass: "lead-create-toast" }),
            editAccessToast && (React.createElement(SalesToasts, { show: editAccessToast, setShow: setEditAccessToast, position: "middle-center", message: React.createElement("span", { dangerouslySetInnerHTML: {
                        __html: editAccessUiState.editAccessMsg,
                    } }), isError: editAccessUiState.isEditAccessErrorState, parentClass: "lead-create-toast assign-lead" })),
            emailPopup && (React.createElement(EdModal, { show: emailPopup, setShow: setEmailPopup, showFooter: false, modalTitle: "send-email commonmodal", children: React.createElement(React.Fragment, null, leadPitchProducts && (React.createElement(SendEmail, { setEmailPopup: setEmailPopup, leadPitchProducts: leadPitchProducts, setToastEmailSuccess: setToastEmailSuccess, email: selectedLead.data.email }))), icon: "edel-icon-msg", title: "Send Email", size: "modal-lg" })),
            emailLoader && (React.createElement(EdModal, { show: emailLoader, setShow: setEmailLoader, showFooter: false, modalTitle: "send-email commonmodal", children: React.createElement(LoadingPopup, { Title: React.createElement("div", { className: "d-flex align-items-center" },
                        React.createElement("i", { className: "edel-icon-msg" }),
                        "Send Email"), message: "Email is getting prepared to send" }) })),
            emailSuccess && (React.createElement(EdModal, { show: emailSuccess, setShow: setEmailSuccess, showFooter: false, modalTitle: "send-email commonmodal", children: React.createElement(SuccessPopup, { setDownloadSuccess: setEmailSuccess, Title: React.createElement("div", { className: "d-flex align-items-center" },
                        React.createElement("i", { className: "edel-icon-msg" }),
                        "Send Email"), message: "Email is successfully sent", operation: "download" }) })),
            emailFailure && (React.createElement(EdModal, { show: emailFailure, setShow: setEmailFailure, showFooter: false, modalTitle: "send-email commonmodal", children: React.createElement(FailurePopup, { setDownloadFail: setEmailFailure, Title: React.createElement("div", { className: "d-flex align-items-center" },
                        React.createElement("i", { className: "edel-icon-msg" }),
                        "Send Email"), operation: "mail" }) })),
            showToast && (React.createElement(GenericToast, { containerPosition: "fixed", backGroundColor: toadtSuccessMsg.isError ? "Danger" : "Light", position: "middle-center", message: toadtSuccessMsg.msg, delay: 3000, autohide: true, title: toadtSuccessMsg.isError ? "Failed" : "Success", close: true, setClose: function () { return setShowToast(false); } })),
            toastMeetingSelection && (React.createElement(GenericToast, { containerPosition: "fixed", backGroundColor: "Dark", position: "middle-center", message: "Please select product, category and sub category fields in order to proceed", delay: 3000, autohide: true, title: "Warning", close: true, setClose: function () { return setToastMeetingSelection(false); } })),
            toastEmailSuccess && (React.createElement(GenericToast, { containerPosition: "fixed", backGroundColor: "Dark", position: "middle-center", message: toastEmailSuccess, delay: 3000, autohide: true, title: "Email Sent!", close: true, setClose: function () { return setToastEmailSuccess(null); } })),
            doneDateConfirmationPopUp && (React.createElement(SalesWarningPopup, { handleOutsideClick: function () { }, closeDropdown: function () { }, size: "modal-md modal-dialog-centered", icon: "edel-icon-download1", modalTitle: "meeting-done-date-popup modalwatchlist commonmodal sales-client lead-warning", title: "Confirmation", showFooter: true, show: doneDateConfirmationPopUp, setShow: function () {
                    setDoneDateConfirmationPopUp(false);
                }, showCloseIcon: true, closeicon: "edel-icon-cross", hideRightButton: true, children: React.createElement("div", { className: "DMSans_16_500 txt_primaryGrey line-140" }, "The selected meeting done will reflect in all the leads where Did Meeting Happen or Did Call Happen has been marked as Yes."), btnvalueleft: {
                    value: "Ok",
                    btnTyp: "midnight-blue",
                    onClick: function (e) {
                        setDoneDateConfirmationPopUp(false);
                    },
                } })),
            showEditableMom && (React.createElement("div", { className: "editable-mom" },
                React.createElement(EdModal, { stopClossOnOutsideClick: true, show: showEditableMom, setShow: setShowEditableMom, showFooter: false, modalTitle: "editable-mom-pop", children: React.createElement(EditableMom, { editableMomText: editableMomText, setEditableMomText: setEditableMomText, emailTemplateResp: emailTemplateResp, setShowEditableMom: setShowEditableMom, isMoMEdited: isMoMEdited, setIsMoMEdited: setIsMoMEdited }), closeDropdown: function () { } }))),
            attachFilePopUp && (React.createElement("div", { className: "attach-file-block" },
                React.createElement(EdModal, { show: attachFilePopUp, setShow: setAttachFilePopUp, showFooter: false, title: "Select Attachment", stopClossOnOutsideClick: true, modalTitle: "", closeDropdown: function () { }, children: React.createElement(FileAttachPopUp, { setAttachFilePopUp: setAttachFilePopUp, setSelectedAttachfile: setSelectedAttachfile, selectedAttachfile: selectedAttachfile }) })))));
    };
    var getMultipleLeads = function (leadID, accCode) {
        setMultipleLeadsLoader(true);
        leadDi.leads
            .getViewEditMultipleLeadsData({ LeadId: leadID, accode: accCode })
            .then(function (resp) {
            var _a, _b;
            if (((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                var multipleLeads_1 = [];
                (_b = resp === null || resp === void 0 ? void 0 : resp.data) === null || _b === void 0 ? void 0 : _b.map(function (respData) {
                    var _a;
                    var singleLead = {
                        productId: respData.productId,
                        categoryId: respData.categoryId,
                        bucketId: respData.bucketId,
                        currentFocusedProduct: 0,
                        responseId: undefined,
                        email: respData.email,
                        phone: respData.mobile,
                        subCategoryId: respData.subCategoryId,
                        displayName: respData.displayName,
                        displayNameId: respData.displayNameId,
                        assignedTo: respData.assignTo,
                        leadSource: respData.leadSource,
                        isMobileVerified: respData.isMobileVerified,
                        isEmailVerified: respData.isEmailVerified,
                        leadType: respData.leadType,
                        participants: respData.didMeetingHappend && respData.isJointMeeting
                            ? respData.participants
                            : null,
                        externalParticipants: respData.didMeetingHappend && respData.isJointMeeting
                            ? respData.externalParticipants
                            : null,
                        primaryOwner: respData.primaryOwner,
                        meetingId: respData.meetingId,
                        expenses: respData.expenses,
                        followupModeId: undefined,
                        followupMode: "",
                        subStatusId: respData.subStatusId,
                        interaction_sub_statusid: respData.interaction_sub_statusid,
                        interaction_sub_status: respData.interaction_sub_status,
                        meetingFollowUpDate: "",
                        meetingFollowUpTime: "",
                        productFeedback: respData.productFeedback,
                        firstName: respData.firstName,
                        lastName: respData === null || respData === void 0 ? void 0 : respData.lastName,
                        sourceId: respData === null || respData === void 0 ? void 0 : respData.sourceId,
                        subSourceId: respData === null || respData === void 0 ? void 0 : respData.subSourceId,
                        productName: respData === null || respData === void 0 ? void 0 : respData.productName,
                        categoryName: respData === null || respData === void 0 ? void 0 : respData.categoryName,
                        subCategoryName: respData === null || respData === void 0 ? void 0 : respData.subCategoryName,
                        acCode: respData === null || respData === void 0 ? void 0 : respData.acCode,
                        acName: respData === null || respData === void 0 ? void 0 : respData.acName,
                        bucketName: respData === null || respData === void 0 ? void 0 : respData.bucketName,
                        typeOfContact: respData === null || respData === void 0 ? void 0 : respData.typeOfContact,
                        didMeetingHappend: respData === null || respData === void 0 ? void 0 : respData.didMeetingHappend,
                        response: "",
                        notes: respData === null || respData === void 0 ? void 0 : respData.notes,
                        remarks: respData === null || respData === void 0 ? void 0 : respData.remarks,
                        sourceName: respData === null || respData === void 0 ? void 0 : respData.sourceName,
                        isJointMeeting: respData === null || respData === void 0 ? void 0 : respData.isJointMeeting,
                        meetingDate: respData === null || respData === void 0 ? void 0 : respData.meetingDate,
                        meetingTime: respData === null || respData === void 0 ? void 0 : respData.meetingTime,
                        subStatus: respData === null || respData === void 0 ? void 0 : respData.subStatus,
                        amount: (respData === null || respData === void 0 ? void 0 : respData.amount) === "0" && !(Number(respData === null || respData === void 0 ? void 0 : respData.amount) > 0)
                            ? ""
                            : respData === null || respData === void 0 ? void 0 : respData.amount,
                        leadId: respData === null || respData === void 0 ? void 0 : respData.leadId,
                        subSourceName: respData === null || respData === void 0 ? void 0 : respData.subSourceName,
                        meetingClosureDate: respData === null || respData === void 0 ? void 0 : respData.meetingClosureDate,
                        meetingClosureTime: respData === null || respData === void 0 ? void 0 : respData.meetingClosureTime,
                        feedbacklist: respData === null || respData === void 0 ? void 0 : respData.feedbacklist,
                        primaryproductName: respData === null || respData === void 0 ? void 0 : respData.productName,
                        primaryproductid: respData === null || respData === void 0 ? void 0 : respData.productId,
                        interaction_priority: respData === null || respData === void 0 ? void 0 : respData.interaction_priority,
                        interaction_priority_id: respData === null || respData === void 0 ? void 0 : respData.interaction_priority_id,
                        isClient: respData === null || respData === void 0 ? void 0 : respData.isClient,
                        isPanVerified: respData === null || respData === void 0 ? void 0 : respData.isPanVerified,
                        isParent: respData === null || respData === void 0 ? void 0 : respData.isParent,
                        pan: respData === null || respData === void 0 ? void 0 : respData.pan,
                        parentLeadId: respData === null || respData === void 0 ? void 0 : respData.parentLeadId,
                        issuerId: respData === null || respData === void 0 ? void 0 : respData.issuerId,
                        issuerName: respData === null || respData === void 0 ? void 0 : respData.issuerName,
                        priorityAgeing: respData === null || respData === void 0 ? void 0 : respData.priorityAgeing,
                        priorityFlag: respData === null || respData === void 0 ? void 0 : respData.priorityFlag,
                        sbCode: respData === null || respData === void 0 ? void 0 : respData.sbCode,
                        sbName: respData === null || respData === void 0 ? void 0 : respData.sbName,
                        sbPassout: respData === null || respData === void 0 ? void 0 : respData.sbPassout,
                        middleName: (_a = respData === null || respData === void 0 ? void 0 : respData.middleName) !== null && _a !== void 0 ? _a : "",
                        dob: respData === null || respData === void 0 ? void 0 : respData.dob,
                        EntityType: respData === null || respData === void 0 ? void 0 : respData.entityType,
                        EntityTypeId: respData === null || respData === void 0 ? void 0 : respData.entityTypeId,
                        UCCCode: respData === null || respData === void 0 ? void 0 : respData.uccCode,
                        isfocus: respData === null || respData === void 0 ? void 0 : respData.isfocus,
                        closuremonth: respData === null || respData === void 0 ? void 0 : respData.closuremonth,
                    };
                    multipleLeads_1.push(singleLead);
                });
                setMultipleSelectedLead({
                    data: __spreadArray([__assign({}, selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data)], __read(resp === null || resp === void 0 ? void 0 : resp.data), false),
                });
                setLeadData(function (prev) {
                    return __spreadArray(__spreadArray([], __read(prev), false), __read(multipleLeads_1), false);
                });
            }
            else {
                setMultipleSelectedLead({
                    data: [__assign({}, selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data)],
                });
            }
            setMultipleLeadsLoader(false);
        })
            .catch(function (error) {
            var _a, _b, _c;
            setMultipleLeadsLoader(false);
            setLeadData([
                __assign(__assign({}, initialMeetingObj), { leadId: leadid ? selectedLead.data.leadId : "", firstName: selectedLead.data.firstName, lastName: selectedLead.data.lastName, email: selectedLead.data.email, phone: selectedLead.data.mobile, acCode: selectedLead.data.acCode, sourceId: selectedLead.data.sourceId, sourceName: selectedLead.data.sourceName, subSourceId: selectedLead.data.subSourceId, subSourceName: selectedLead.data.subSourceName, isEmailVerified: selectedLead.data.isEmailVerified, isMobileVerified: selectedLead.data.isMobileVerified, pan: selectedLead.data.pan, UCCCode: ((_a = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _a === void 0 ? void 0 : _a.isClient) && ((_b = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _b === void 0 ? void 0 : _b.uccCode)
                        ? (_c = selectedLead === null || selectedLead === void 0 ? void 0 : selectedLead.data) === null || _c === void 0 ? void 0 : _c.uccCode
                        : "" }),
            ]);
        });
    };
    useEffect(function () {
        if (showHideForLoginType().showSubChildSection) {
            getChildLeadData();
        }
    }, [showHideForLoginType().showSubChildSection]);
    return (React.createElement("div", { className: "p-15 primary-lead-operation-container" }, leadid ? (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "flexJustifySpaceBetween m-0 newlead-page-tile", id: "pastintercation-backtotop-main" },
            React.createElement(Col, { className: "DMSan_28_700 txt-midnight-blue px-0  lh-140" }, "Edit Lead")),
        generateMainComp())) : (React.createElement(React.Fragment, null, ((_m = showHideForLoginType()) === null || _m === void 0 ? void 0 : _m.addParentLeadId) ? (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "flexJustifySpaceBetween m-0 newlead-page-tile" },
            React.createElement(Col, { className: "DMSan_28_700 txt-midnight-blue px-0  " }, "Add New Lead")),
        generateMainComp())) : (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "flexJustifySpaceBetween m-0 newlead-page-tile" },
            React.createElement(Col, { className: "DMSan_28_700 txt-midnight-blue px-0 " }, "Add New Lead")),
        React.createElement(GenericTabs, { defaultActiveKey: selectedTab, key: selectedTab, tabsArray: getTabsList(), externalClassName: "lead-creation-tabs-container w-100", callBackFunction: function (key) {
                setSelectedLead({ data: undefined });
                setIsAddNewLead(false);
                setIsPartnerNewLead(false);
                setSelectedTab(key);
                setGlobleDisable(false);
                setLeadData([initMeetingData]);
                setRefreshPageValue(true);
            } })))))));
};
